/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import {Route as rootRoute} from './../../routes/__root';
import {Route as sharedRouteImport} from './../../routes/(shared)/route';
import {Route as publicRouteImport} from './../../routes/(public)/route';
import {Route as practitionerRouteImport} from './../../routes/(practitioner)/route';
import {Route as patientRouteImport} from './../../routes/(patient)/route';
import {Route as anonymousRouteImport} from './../../routes/(anonymous)/route';
import {Route as sharedProfileImport} from './../../routes/(shared)/profile';
import {Route as sharedNotificationsImport} from './../../routes/(shared)/notifications';
import {Route as sharedLogoutImport} from './../../routes/(shared)/logout';
import {Route as sharedHomeImport} from './../../routes/(shared)/home';
import {Route as sharedContactImport} from './../../routes/(shared)/contact';
import {Route as sharedBackupImport} from './../../routes/(shared)/backup';
import {Route as sharedAuditLogImport} from './../../routes/(shared)/audit-log';
import {Route as publicSupportImport} from './../../routes/(public)/support';
import {Route as publicLegalImport} from './../../routes/(public)/legal';
import {Route as practitionerPatientsImport} from './../../routes/(practitioner)/patients';
import {Route as practitionerDiagnosticReportsImport} from './../../routes/(practitioner)/diagnostic-reports';
import {Route as practitionerCompanyImport} from './../../routes/(practitioner)/company';
import {Route as patientMedicationRequestsImport} from './../../routes/(patient)/medication-requests';
import {Route as patientGlobalDiagnosticReportsImport} from './../../routes/(patient)/global-diagnostic-reports';
import {Route as patientEventsImport} from './../../routes/(patient)/events';
import {Route as patientEncountersImport} from './../../routes/(patient)/encounters';
import {Route as patientDocumentsImport} from './../../routes/(patient)/documents';
import {Route as patientDiagnosticReportsImport} from './../../routes/(patient)/diagnostic-reports';
import {Route as anonymousResetPasswordImport} from './../../routes/(anonymous)/reset-password';
import {Route as anonymousRegisterImport} from './../../routes/(anonymous)/register';
import {Route as anonymousRecoverPasswordImport} from './../../routes/(anonymous)/recover-password';
import {Route as anonymousPatientSignupImport} from './../../routes/(anonymous)/patient-signup';
import {Route as anonymousLoginImport} from './../../routes/(anonymous)/login';
import {Route as anonymousConfirmAccountImport} from './../../routes/(anonymous)/confirm-account';
import {Route as anonymousConfirmImport} from './../../routes/(anonymous)/confirm';
import {Route as anonymousAppHomeImport} from './../../routes/(anonymous)/app-home';
import {Route as sharedEventsEventIdImport} from './../../routes/(shared)/events/$eventId';
import {Route as publicDisableEmailsTokenImport} from './../../routes/(public)/disable-emails/$token';
import {Route as practitionerPractitionerWorkListImport} from './../../routes/(practitioner)/practitioner/work-list';
import {Route as practitionerPractitionerQuickDiagnosticReportRequestImport} from './../../routes/(practitioner)/practitioner/quick-diagnostic-report-request';
import {Route as practitionerPractitionerPatientPaymentOrdersImport} from './../../routes/(practitioner)/practitioner/patient-payment-orders';
import {Route as practitionerPractitionerDiagnosticReportSentImport} from './../../routes/(practitioner)/practitioner/diagnostic-report-sent';
import {Route as practitionerPractitionerDiagnosticReportRequestImport} from './../../routes/(practitioner)/practitioner/diagnostic-report-request';
import {Route as practitionerPractitionerActivityImport} from './../../routes/(practitioner)/practitioner/activity';
import {Route as practitionerPatientsCreateImport} from './../../routes/(practitioner)/patients/create';
import {Route as practitionerPatientsPatientIdImport} from './../../routes/(practitioner)/patients/$patientId';
import {Route as practitionerCompanyPractitionersImport} from './../../routes/(practitioner)/company/practitioners';
import {Route as practitionerCompanyPathologyCustomizationImport} from './../../routes/(practitioner)/company/pathology-customization';
import {Route as practitionerCompanyMetricsImport} from './../../routes/(practitioner)/company/metrics';
import {Route as practitionerCompanyInactiveCompanyImport} from './../../routes/(practitioner)/company/inactive-company';
import {Route as patientPatientPsoriasisInfoImport} from './../../routes/(patient)/patient/psoriasis-info';
import {Route as patientPatientPaymentOrdersImport} from './../../routes/(patient)/patient/payment-orders';
import {Route as patientPatientDiagnosticReportSentImport} from './../../routes/(patient)/patient/diagnostic-report-sent';
import {Route as patientPatientDiagnosticReportRequestImport} from './../../routes/(patient)/patient/diagnostic-report-request';
import {Route as patientDocumentsCreateImport} from './../../routes/(patient)/documents/create';
import {Route as patientDiagnosticReportsDiagnosticReportIdImport} from './../../routes/(patient)/diagnostic-reports/$diagnosticReportId';
import {Route as sharedMedicationRequestsMedicationRequestIdPdfImport} from './../../routes/(shared)/medication-requests/$medicationRequestId/pdf';
import {Route as practitionerPractitionersPractitionerIdRecoverPasswordImport} from './../../routes/(practitioner)/practitioners/$practitionerId/recover-password';
import {Route as practitionerPractitionerPatientPaymentOrdersCreateImport} from './../../routes/(practitioner)/practitioner/patient-payment-orders/create';
import {Route as practitionerPractitionerMedicationRequestsCreateImport} from './../../routes/(practitioner)/practitioner/medication-requests/create';
import {Route as practitionerPractitionerEventsCreateImport} from './../../routes/(practitioner)/practitioner/events/create';
import {Route as practitionerPractitionerEventsEventIdImport} from './../../routes/(practitioner)/practitioner/events/$eventId';
import {Route as practitionerPractitionerActivityDateImport} from './../../routes/(practitioner)/practitioner/activity/$date';
import {Route as practitionerPatientsPatientIdTerminateStudyImport} from './../../routes/(practitioner)/patients/$patientId/terminate-study';
import {Route as practitionerPatientsPatientIdRecoverPasswordImport} from './../../routes/(practitioner)/patients/$patientId/recover-password';
import {Route as practitionerPatientsPatientIdPatientInteractionsImport} from './../../routes/(practitioner)/patients/$patientId/patient-interactions';
import {Route as practitionerPatientsPatientIdDeleteImport} from './../../routes/(practitioner)/patients/$patientId/delete';
import {Route as practitionerCompanyPractitionersCreateImport} from './../../routes/(practitioner)/company/practitioners/create';
import {Route as practitionerCompanyPractitionersPractitionerIdImport} from './../../routes/(practitioner)/company/practitioners/$practitionerId';
import {Route as practitionerCompanyPathologyCustomizationCreateImport} from './../../routes/(practitioner)/company/pathology-customization/create';
import {Route as practitionerPractitionerMedicationRequestsMedicationRequestIdEditImport} from './../../routes/(practitioner)/practitioner/medication-requests/$medicationRequestId/edit';
import {Route as practitionerPractitionerMedicationRequestsMedicationRequestIdDeleteImport} from './../../routes/(practitioner)/practitioner/medication-requests/$medicationRequestId/delete';
import {Route as practitionerPatientsPatientIdTemporaryImagesUploadImport} from './../../routes/(practitioner)/patients/$patientId/temporary-images/upload';
import {Route as practitionerPatientsPatientIdEncountersEncounterIdImport} from './../../routes/(practitioner)/patients/$patientId/encounters/$encounterId';
import {Route as practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdImport} from './../../routes/(practitioner)/patients/$patientId/diagnostic-report/$diagnosticReportId';
import {Route as practitionerCompanyPractitionersPractitionerIdDeleteImport} from './../../routes/(practitioner)/company/practitioners/$practitionerId/delete';
import {Route as practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteImport} from './../../routes/(practitioner)/company/pathology-overrides/$pathologyOverrideId/delete';
import {Route as practitionerCompanyPathologyCustomizationPathologyIdEditImport} from './../../routes/(practitioner)/company/pathology-customization/$pathologyId/edit';
import {Route as patientPatientPaymentOrdersPaymentOrderIdPayImport} from './../../routes/(patient)/patient/payment-orders/$paymentOrderId/pay';

// Create/Update Routes

const sharedRouteRoute = sharedRouteImport.update({
  id: '/(shared)',
  getParentRoute: () => rootRoute
} as any);

const publicRouteRoute = publicRouteImport.update({
  id: '/(public)',
  getParentRoute: () => rootRoute
} as any);

const practitionerRouteRoute = practitionerRouteImport.update({
  id: '/(practitioner)',
  getParentRoute: () => rootRoute
} as any);

const patientRouteRoute = patientRouteImport.update({
  id: '/(patient)',
  getParentRoute: () => rootRoute
} as any);

const anonymousRouteRoute = anonymousRouteImport.update({
  id: '/(anonymous)',
  getParentRoute: () => rootRoute
} as any);

const sharedProfileRoute = sharedProfileImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => sharedRouteRoute
} as any);

const sharedNotificationsRoute = sharedNotificationsImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => sharedRouteRoute
} as any);

const sharedLogoutRoute = sharedLogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => sharedRouteRoute
} as any);

const sharedHomeRoute = sharedHomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => sharedRouteRoute
} as any);

const sharedContactRoute = sharedContactImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => sharedRouteRoute
} as any);

const sharedBackupRoute = sharedBackupImport.update({
  id: '/backup',
  path: '/backup',
  getParentRoute: () => sharedRouteRoute
} as any);

const sharedAuditLogRoute = sharedAuditLogImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => sharedRouteRoute
} as any);

const publicSupportRoute = publicSupportImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => publicRouteRoute
} as any);

const publicLegalRoute = publicLegalImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => publicRouteRoute
} as any);

const practitionerPatientsRoute = practitionerPatientsImport.update({
  id: '/patients',
  path: '/patients',
  getParentRoute: () => practitionerRouteRoute
} as any);

const practitionerDiagnosticReportsRoute = practitionerDiagnosticReportsImport.update({
  id: '/diagnostic-reports',
  path: '/diagnostic-reports',
  getParentRoute: () => practitionerRouteRoute
} as any);

const practitionerCompanyRoute = practitionerCompanyImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => practitionerRouteRoute
} as any);

const patientMedicationRequestsRoute = patientMedicationRequestsImport.update({
  id: '/medication-requests',
  path: '/medication-requests',
  getParentRoute: () => patientRouteRoute
} as any);

const patientGlobalDiagnosticReportsRoute = patientGlobalDiagnosticReportsImport.update({
  id: '/global-diagnostic-reports',
  path: '/global-diagnostic-reports',
  getParentRoute: () => patientRouteRoute
} as any);

const patientEventsRoute = patientEventsImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => patientRouteRoute
} as any);

const patientEncountersRoute = patientEncountersImport.update({
  id: '/encounters',
  path: '/encounters',
  getParentRoute: () => patientRouteRoute
} as any);

const patientDocumentsRoute = patientDocumentsImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => patientRouteRoute
} as any);

const patientDiagnosticReportsRoute = patientDiagnosticReportsImport.update({
  id: '/diagnostic-reports',
  path: '/diagnostic-reports',
  getParentRoute: () => patientRouteRoute
} as any);

const anonymousResetPasswordRoute = anonymousResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => anonymousRouteRoute
} as any);

const anonymousRegisterRoute = anonymousRegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => anonymousRouteRoute
} as any);

const anonymousRecoverPasswordRoute = anonymousRecoverPasswordImport.update({
  id: '/recover-password',
  path: '/recover-password',
  getParentRoute: () => anonymousRouteRoute
} as any);

const anonymousPatientSignupRoute = anonymousPatientSignupImport.update({
  id: '/patient-signup',
  path: '/patient-signup',
  getParentRoute: () => anonymousRouteRoute
} as any);

const anonymousLoginRoute = anonymousLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => anonymousRouteRoute
} as any);

const anonymousConfirmAccountRoute = anonymousConfirmAccountImport.update({
  id: '/confirm-account',
  path: '/confirm-account',
  getParentRoute: () => anonymousRouteRoute
} as any);

const anonymousConfirmRoute = anonymousConfirmImport.update({
  id: '/confirm',
  path: '/confirm',
  getParentRoute: () => anonymousRouteRoute
} as any);

const anonymousAppHomeRoute = anonymousAppHomeImport.update({
  id: '/app-home',
  path: '/app-home',
  getParentRoute: () => anonymousRouteRoute
} as any);

const sharedEventsEventIdRoute = sharedEventsEventIdImport.update({
  id: '/events/$eventId',
  path: '/events/$eventId',
  getParentRoute: () => sharedRouteRoute
} as any);

const publicDisableEmailsTokenRoute = publicDisableEmailsTokenImport.update({
  id: '/disable-emails/$token',
  path: '/disable-emails/$token',
  getParentRoute: () => publicRouteRoute
} as any);

const practitionerPractitionerWorkListRoute = practitionerPractitionerWorkListImport.update({
  id: '/practitioner/work-list',
  path: '/practitioner/work-list',
  getParentRoute: () => practitionerRouteRoute
} as any);

const practitionerPractitionerQuickDiagnosticReportRequestRoute =
  practitionerPractitionerQuickDiagnosticReportRequestImport.update({
    id: '/practitioner/quick-diagnostic-report-request',
    path: '/practitioner/quick-diagnostic-report-request',
    getParentRoute: () => practitionerRouteRoute
  } as any);

const practitionerPractitionerPatientPaymentOrdersRoute =
  practitionerPractitionerPatientPaymentOrdersImport.update({
    id: '/practitioner/patient-payment-orders',
    path: '/practitioner/patient-payment-orders',
    getParentRoute: () => practitionerRouteRoute
  } as any);

const practitionerPractitionerDiagnosticReportSentRoute =
  practitionerPractitionerDiagnosticReportSentImport.update({
    id: '/practitioner/diagnostic-report-sent',
    path: '/practitioner/diagnostic-report-sent',
    getParentRoute: () => practitionerRouteRoute
  } as any);

const practitionerPractitionerDiagnosticReportRequestRoute =
  practitionerPractitionerDiagnosticReportRequestImport.update({
    id: '/practitioner/diagnostic-report-request',
    path: '/practitioner/diagnostic-report-request',
    getParentRoute: () => practitionerRouteRoute
  } as any);

const practitionerPractitionerActivityRoute = practitionerPractitionerActivityImport.update({
  id: '/practitioner/activity',
  path: '/practitioner/activity',
  getParentRoute: () => practitionerRouteRoute
} as any);

const practitionerPatientsCreateRoute = practitionerPatientsCreateImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => practitionerPatientsRoute
} as any);

const practitionerPatientsPatientIdRoute = practitionerPatientsPatientIdImport.update({
  id: '/$patientId',
  path: '/$patientId',
  getParentRoute: () => practitionerPatientsRoute
} as any);

const practitionerCompanyPractitionersRoute = practitionerCompanyPractitionersImport.update({
  id: '/practitioners',
  path: '/practitioners',
  getParentRoute: () => practitionerCompanyRoute
} as any);

const practitionerCompanyPathologyCustomizationRoute =
  practitionerCompanyPathologyCustomizationImport.update({
    id: '/pathology-customization',
    path: '/pathology-customization',
    getParentRoute: () => practitionerCompanyRoute
  } as any);

const practitionerCompanyMetricsRoute = practitionerCompanyMetricsImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => practitionerCompanyRoute
} as any);

const practitionerCompanyInactiveCompanyRoute = practitionerCompanyInactiveCompanyImport.update({
  id: '/inactive-company',
  path: '/inactive-company',
  getParentRoute: () => practitionerCompanyRoute
} as any);

const patientPatientPsoriasisInfoRoute = patientPatientPsoriasisInfoImport.update({
  id: '/patient/psoriasis-info',
  path: '/patient/psoriasis-info',
  getParentRoute: () => patientRouteRoute
} as any);

const patientPatientPaymentOrdersRoute = patientPatientPaymentOrdersImport.update({
  id: '/patient/payment-orders',
  path: '/patient/payment-orders',
  getParentRoute: () => patientRouteRoute
} as any);

const patientPatientDiagnosticReportSentRoute = patientPatientDiagnosticReportSentImport.update({
  id: '/patient/diagnostic-report-sent',
  path: '/patient/diagnostic-report-sent',
  getParentRoute: () => patientRouteRoute
} as any);

const patientPatientDiagnosticReportRequestRoute =
  patientPatientDiagnosticReportRequestImport.update({
    id: '/patient/diagnostic-report-request',
    path: '/patient/diagnostic-report-request',
    getParentRoute: () => patientRouteRoute
  } as any);

const patientDocumentsCreateRoute = patientDocumentsCreateImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => patientDocumentsRoute
} as any);

const patientDiagnosticReportsDiagnosticReportIdRoute =
  patientDiagnosticReportsDiagnosticReportIdImport.update({
    id: '/$diagnosticReportId',
    path: '/$diagnosticReportId',
    getParentRoute: () => patientDiagnosticReportsRoute
  } as any);

const sharedMedicationRequestsMedicationRequestIdPdfRoute =
  sharedMedicationRequestsMedicationRequestIdPdfImport.update({
    id: '/medication-requests/$medicationRequestId/pdf',
    path: '/medication-requests/$medicationRequestId/pdf',
    getParentRoute: () => sharedRouteRoute
  } as any);

const practitionerPractitionersPractitionerIdRecoverPasswordRoute =
  practitionerPractitionersPractitionerIdRecoverPasswordImport.update({
    id: '/practitioners/$practitionerId/recover-password',
    path: '/practitioners/$practitionerId/recover-password',
    getParentRoute: () => practitionerRouteRoute
  } as any);

const practitionerPractitionerPatientPaymentOrdersCreateRoute =
  practitionerPractitionerPatientPaymentOrdersCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => practitionerPractitionerPatientPaymentOrdersRoute
  } as any);

const practitionerPractitionerMedicationRequestsCreateRoute =
  practitionerPractitionerMedicationRequestsCreateImport.update({
    id: '/practitioner/medication-requests/create',
    path: '/practitioner/medication-requests/create',
    getParentRoute: () => practitionerRouteRoute
  } as any);

const practitionerPractitionerEventsCreateRoute = practitionerPractitionerEventsCreateImport.update(
  {
    id: '/practitioner/events/create',
    path: '/practitioner/events/create',
    getParentRoute: () => practitionerRouteRoute
  } as any
);

const practitionerPractitionerEventsEventIdRoute =
  practitionerPractitionerEventsEventIdImport.update({
    id: '/practitioner/events/$eventId',
    path: '/practitioner/events/$eventId',
    getParentRoute: () => practitionerRouteRoute
  } as any);

const practitionerPractitionerActivityDateRoute = practitionerPractitionerActivityDateImport.update(
  {
    id: '/$date',
    path: '/$date',
    getParentRoute: () => practitionerPractitionerActivityRoute
  } as any
);

const practitionerPatientsPatientIdTerminateStudyRoute =
  practitionerPatientsPatientIdTerminateStudyImport.update({
    id: '/terminate-study',
    path: '/terminate-study',
    getParentRoute: () => practitionerPatientsPatientIdRoute
  } as any);

const practitionerPatientsPatientIdRecoverPasswordRoute =
  practitionerPatientsPatientIdRecoverPasswordImport.update({
    id: '/recover-password',
    path: '/recover-password',
    getParentRoute: () => practitionerPatientsPatientIdRoute
  } as any);

const practitionerPatientsPatientIdPatientInteractionsRoute =
  practitionerPatientsPatientIdPatientInteractionsImport.update({
    id: '/patient-interactions',
    path: '/patient-interactions',
    getParentRoute: () => practitionerPatientsPatientIdRoute
  } as any);

const practitionerPatientsPatientIdDeleteRoute = practitionerPatientsPatientIdDeleteImport.update({
  id: '/delete',
  path: '/delete',
  getParentRoute: () => practitionerPatientsPatientIdRoute
} as any);

const practitionerCompanyPractitionersCreateRoute =
  practitionerCompanyPractitionersCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => practitionerCompanyPractitionersRoute
  } as any);

const practitionerCompanyPractitionersPractitionerIdRoute =
  practitionerCompanyPractitionersPractitionerIdImport.update({
    id: '/$practitionerId',
    path: '/$practitionerId',
    getParentRoute: () => practitionerCompanyPractitionersRoute
  } as any);

const practitionerCompanyPathologyCustomizationCreateRoute =
  practitionerCompanyPathologyCustomizationCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => practitionerCompanyPathologyCustomizationRoute
  } as any);

const practitionerPractitionerMedicationRequestsMedicationRequestIdEditRoute =
  practitionerPractitionerMedicationRequestsMedicationRequestIdEditImport.update({
    id: '/practitioner/medication-requests/$medicationRequestId/edit',
    path: '/practitioner/medication-requests/$medicationRequestId/edit',
    getParentRoute: () => practitionerRouteRoute
  } as any);

const practitionerPractitionerMedicationRequestsMedicationRequestIdDeleteRoute =
  practitionerPractitionerMedicationRequestsMedicationRequestIdDeleteImport.update({
    id: '/practitioner/medication-requests/$medicationRequestId/delete',
    path: '/practitioner/medication-requests/$medicationRequestId/delete',
    getParentRoute: () => practitionerRouteRoute
  } as any);

const practitionerPatientsPatientIdTemporaryImagesUploadRoute =
  practitionerPatientsPatientIdTemporaryImagesUploadImport.update({
    id: '/temporary-images/upload',
    path: '/temporary-images/upload',
    getParentRoute: () => practitionerPatientsPatientIdRoute
  } as any);

const practitionerPatientsPatientIdEncountersEncounterIdRoute =
  practitionerPatientsPatientIdEncountersEncounterIdImport.update({
    id: '/encounters/$encounterId',
    path: '/encounters/$encounterId',
    getParentRoute: () => practitionerPatientsPatientIdRoute
  } as any);

const practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRoute =
  practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdImport.update({
    id: '/diagnostic-report/$diagnosticReportId',
    path: '/diagnostic-report/$diagnosticReportId',
    getParentRoute: () => practitionerPatientsPatientIdRoute
  } as any);

const practitionerCompanyPractitionersPractitionerIdDeleteRoute =
  practitionerCompanyPractitionersPractitionerIdDeleteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => practitionerCompanyPractitionersPractitionerIdRoute
  } as any);

const practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRoute =
  practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteImport.update({
    id: '/pathology-overrides/$pathologyOverrideId/delete',
    path: '/pathology-overrides/$pathologyOverrideId/delete',
    getParentRoute: () => practitionerCompanyRoute
  } as any);

const practitionerCompanyPathologyCustomizationPathologyIdEditRoute =
  practitionerCompanyPathologyCustomizationPathologyIdEditImport.update({
    id: '/$pathologyId/edit',
    path: '/$pathologyId/edit',
    getParentRoute: () => practitionerCompanyPathologyCustomizationRoute
  } as any);

const patientPatientPaymentOrdersPaymentOrderIdPayRoute =
  patientPatientPaymentOrdersPaymentOrderIdPayImport.update({
    id: '/$paymentOrderId/pay',
    path: '/$paymentOrderId/pay',
    getParentRoute: () => patientPatientPaymentOrdersRoute
  } as any);

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(anonymous)': {
      id: '/(anonymous)';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof anonymousRouteImport;
      parentRoute: typeof rootRoute;
    };
    '/(patient)': {
      id: '/(patient)';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof patientRouteImport;
      parentRoute: typeof rootRoute;
    };
    '/(practitioner)': {
      id: '/(practitioner)';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof practitionerRouteImport;
      parentRoute: typeof rootRoute;
    };
    '/(public)': {
      id: '/(public)';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof publicRouteImport;
      parentRoute: typeof rootRoute;
    };
    '/(shared)': {
      id: '/(shared)';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof sharedRouteImport;
      parentRoute: typeof rootRoute;
    };
    '/(anonymous)/app-home': {
      id: '/(anonymous)/app-home';
      path: '/app-home';
      fullPath: '/app-home';
      preLoaderRoute: typeof anonymousAppHomeImport;
      parentRoute: typeof anonymousRouteImport;
    };
    '/(anonymous)/confirm': {
      id: '/(anonymous)/confirm';
      path: '/confirm';
      fullPath: '/confirm';
      preLoaderRoute: typeof anonymousConfirmImport;
      parentRoute: typeof anonymousRouteImport;
    };
    '/(anonymous)/confirm-account': {
      id: '/(anonymous)/confirm-account';
      path: '/confirm-account';
      fullPath: '/confirm-account';
      preLoaderRoute: typeof anonymousConfirmAccountImport;
      parentRoute: typeof anonymousRouteImport;
    };
    '/(anonymous)/login': {
      id: '/(anonymous)/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof anonymousLoginImport;
      parentRoute: typeof anonymousRouteImport;
    };
    '/(anonymous)/patient-signup': {
      id: '/(anonymous)/patient-signup';
      path: '/patient-signup';
      fullPath: '/patient-signup';
      preLoaderRoute: typeof anonymousPatientSignupImport;
      parentRoute: typeof anonymousRouteImport;
    };
    '/(anonymous)/recover-password': {
      id: '/(anonymous)/recover-password';
      path: '/recover-password';
      fullPath: '/recover-password';
      preLoaderRoute: typeof anonymousRecoverPasswordImport;
      parentRoute: typeof anonymousRouteImport;
    };
    '/(anonymous)/register': {
      id: '/(anonymous)/register';
      path: '/register';
      fullPath: '/register';
      preLoaderRoute: typeof anonymousRegisterImport;
      parentRoute: typeof anonymousRouteImport;
    };
    '/(anonymous)/reset-password': {
      id: '/(anonymous)/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof anonymousResetPasswordImport;
      parentRoute: typeof anonymousRouteImport;
    };
    '/(patient)/diagnostic-reports': {
      id: '/(patient)/diagnostic-reports';
      path: '/diagnostic-reports';
      fullPath: '/diagnostic-reports';
      preLoaderRoute: typeof patientDiagnosticReportsImport;
      parentRoute: typeof patientRouteImport;
    };
    '/(patient)/documents': {
      id: '/(patient)/documents';
      path: '/documents';
      fullPath: '/documents';
      preLoaderRoute: typeof patientDocumentsImport;
      parentRoute: typeof patientRouteImport;
    };
    '/(patient)/encounters': {
      id: '/(patient)/encounters';
      path: '/encounters';
      fullPath: '/encounters';
      preLoaderRoute: typeof patientEncountersImport;
      parentRoute: typeof patientRouteImport;
    };
    '/(patient)/events': {
      id: '/(patient)/events';
      path: '/events';
      fullPath: '/events';
      preLoaderRoute: typeof patientEventsImport;
      parentRoute: typeof patientRouteImport;
    };
    '/(patient)/global-diagnostic-reports': {
      id: '/(patient)/global-diagnostic-reports';
      path: '/global-diagnostic-reports';
      fullPath: '/global-diagnostic-reports';
      preLoaderRoute: typeof patientGlobalDiagnosticReportsImport;
      parentRoute: typeof patientRouteImport;
    };
    '/(patient)/medication-requests': {
      id: '/(patient)/medication-requests';
      path: '/medication-requests';
      fullPath: '/medication-requests';
      preLoaderRoute: typeof patientMedicationRequestsImport;
      parentRoute: typeof patientRouteImport;
    };
    '/(practitioner)/company': {
      id: '/(practitioner)/company';
      path: '/company';
      fullPath: '/company';
      preLoaderRoute: typeof practitionerCompanyImport;
      parentRoute: typeof practitionerRouteImport;
    };
    '/(practitioner)/diagnostic-reports': {
      id: '/(practitioner)/diagnostic-reports';
      path: '/diagnostic-reports';
      fullPath: '/diagnostic-reports';
      preLoaderRoute: typeof practitionerDiagnosticReportsImport;
      parentRoute: typeof practitionerRouteImport;
    };
    '/(practitioner)/patients': {
      id: '/(practitioner)/patients';
      path: '/patients';
      fullPath: '/patients';
      preLoaderRoute: typeof practitionerPatientsImport;
      parentRoute: typeof practitionerRouteImport;
    };
    '/(public)/legal': {
      id: '/(public)/legal';
      path: '/legal';
      fullPath: '/legal';
      preLoaderRoute: typeof publicLegalImport;
      parentRoute: typeof publicRouteImport;
    };
    '/(public)/support': {
      id: '/(public)/support';
      path: '/support';
      fullPath: '/support';
      preLoaderRoute: typeof publicSupportImport;
      parentRoute: typeof publicRouteImport;
    };
    '/(shared)/audit-log': {
      id: '/(shared)/audit-log';
      path: '/audit-log';
      fullPath: '/audit-log';
      preLoaderRoute: typeof sharedAuditLogImport;
      parentRoute: typeof sharedRouteImport;
    };
    '/(shared)/backup': {
      id: '/(shared)/backup';
      path: '/backup';
      fullPath: '/backup';
      preLoaderRoute: typeof sharedBackupImport;
      parentRoute: typeof sharedRouteImport;
    };
    '/(shared)/contact': {
      id: '/(shared)/contact';
      path: '/contact';
      fullPath: '/contact';
      preLoaderRoute: typeof sharedContactImport;
      parentRoute: typeof sharedRouteImport;
    };
    '/(shared)/home': {
      id: '/(shared)/home';
      path: '/home';
      fullPath: '/home';
      preLoaderRoute: typeof sharedHomeImport;
      parentRoute: typeof sharedRouteImport;
    };
    '/(shared)/logout': {
      id: '/(shared)/logout';
      path: '/logout';
      fullPath: '/logout';
      preLoaderRoute: typeof sharedLogoutImport;
      parentRoute: typeof sharedRouteImport;
    };
    '/(shared)/notifications': {
      id: '/(shared)/notifications';
      path: '/notifications';
      fullPath: '/notifications';
      preLoaderRoute: typeof sharedNotificationsImport;
      parentRoute: typeof sharedRouteImport;
    };
    '/(shared)/profile': {
      id: '/(shared)/profile';
      path: '/profile';
      fullPath: '/profile';
      preLoaderRoute: typeof sharedProfileImport;
      parentRoute: typeof sharedRouteImport;
    };
    '/(patient)/diagnostic-reports/$diagnosticReportId': {
      id: '/(patient)/diagnostic-reports/$diagnosticReportId';
      path: '/$diagnosticReportId';
      fullPath: '/diagnostic-reports/$diagnosticReportId';
      preLoaderRoute: typeof patientDiagnosticReportsDiagnosticReportIdImport;
      parentRoute: typeof patientDiagnosticReportsImport;
    };
    '/(patient)/documents/create': {
      id: '/(patient)/documents/create';
      path: '/create';
      fullPath: '/documents/create';
      preLoaderRoute: typeof patientDocumentsCreateImport;
      parentRoute: typeof patientDocumentsImport;
    };
    '/(patient)/patient/diagnostic-report-request': {
      id: '/(patient)/patient/diagnostic-report-request';
      path: '/patient/diagnostic-report-request';
      fullPath: '/patient/diagnostic-report-request';
      preLoaderRoute: typeof patientPatientDiagnosticReportRequestImport;
      parentRoute: typeof patientRouteImport;
    };
    '/(patient)/patient/diagnostic-report-sent': {
      id: '/(patient)/patient/diagnostic-report-sent';
      path: '/patient/diagnostic-report-sent';
      fullPath: '/patient/diagnostic-report-sent';
      preLoaderRoute: typeof patientPatientDiagnosticReportSentImport;
      parentRoute: typeof patientRouteImport;
    };
    '/(patient)/patient/payment-orders': {
      id: '/(patient)/patient/payment-orders';
      path: '/patient/payment-orders';
      fullPath: '/patient/payment-orders';
      preLoaderRoute: typeof patientPatientPaymentOrdersImport;
      parentRoute: typeof patientRouteImport;
    };
    '/(patient)/patient/psoriasis-info': {
      id: '/(patient)/patient/psoriasis-info';
      path: '/patient/psoriasis-info';
      fullPath: '/patient/psoriasis-info';
      preLoaderRoute: typeof patientPatientPsoriasisInfoImport;
      parentRoute: typeof patientRouteImport;
    };
    '/(practitioner)/company/inactive-company': {
      id: '/(practitioner)/company/inactive-company';
      path: '/inactive-company';
      fullPath: '/company/inactive-company';
      preLoaderRoute: typeof practitionerCompanyInactiveCompanyImport;
      parentRoute: typeof practitionerCompanyImport;
    };
    '/(practitioner)/company/metrics': {
      id: '/(practitioner)/company/metrics';
      path: '/metrics';
      fullPath: '/company/metrics';
      preLoaderRoute: typeof practitionerCompanyMetricsImport;
      parentRoute: typeof practitionerCompanyImport;
    };
    '/(practitioner)/company/pathology-customization': {
      id: '/(practitioner)/company/pathology-customization';
      path: '/pathology-customization';
      fullPath: '/company/pathology-customization';
      preLoaderRoute: typeof practitionerCompanyPathologyCustomizationImport;
      parentRoute: typeof practitionerCompanyImport;
    };
    '/(practitioner)/company/practitioners': {
      id: '/(practitioner)/company/practitioners';
      path: '/practitioners';
      fullPath: '/company/practitioners';
      preLoaderRoute: typeof practitionerCompanyPractitionersImport;
      parentRoute: typeof practitionerCompanyImport;
    };
    '/(practitioner)/patients/$patientId': {
      id: '/(practitioner)/patients/$patientId';
      path: '/$patientId';
      fullPath: '/patients/$patientId';
      preLoaderRoute: typeof practitionerPatientsPatientIdImport;
      parentRoute: typeof practitionerPatientsImport;
    };
    '/(practitioner)/patients/create': {
      id: '/(practitioner)/patients/create';
      path: '/create';
      fullPath: '/patients/create';
      preLoaderRoute: typeof practitionerPatientsCreateImport;
      parentRoute: typeof practitionerPatientsImport;
    };
    '/(practitioner)/practitioner/activity': {
      id: '/(practitioner)/practitioner/activity';
      path: '/practitioner/activity';
      fullPath: '/practitioner/activity';
      preLoaderRoute: typeof practitionerPractitionerActivityImport;
      parentRoute: typeof practitionerRouteImport;
    };
    '/(practitioner)/practitioner/diagnostic-report-request': {
      id: '/(practitioner)/practitioner/diagnostic-report-request';
      path: '/practitioner/diagnostic-report-request';
      fullPath: '/practitioner/diagnostic-report-request';
      preLoaderRoute: typeof practitionerPractitionerDiagnosticReportRequestImport;
      parentRoute: typeof practitionerRouteImport;
    };
    '/(practitioner)/practitioner/diagnostic-report-sent': {
      id: '/(practitioner)/practitioner/diagnostic-report-sent';
      path: '/practitioner/diagnostic-report-sent';
      fullPath: '/practitioner/diagnostic-report-sent';
      preLoaderRoute: typeof practitionerPractitionerDiagnosticReportSentImport;
      parentRoute: typeof practitionerRouteImport;
    };
    '/(practitioner)/practitioner/patient-payment-orders': {
      id: '/(practitioner)/practitioner/patient-payment-orders';
      path: '/practitioner/patient-payment-orders';
      fullPath: '/practitioner/patient-payment-orders';
      preLoaderRoute: typeof practitionerPractitionerPatientPaymentOrdersImport;
      parentRoute: typeof practitionerRouteImport;
    };
    '/(practitioner)/practitioner/quick-diagnostic-report-request': {
      id: '/(practitioner)/practitioner/quick-diagnostic-report-request';
      path: '/practitioner/quick-diagnostic-report-request';
      fullPath: '/practitioner/quick-diagnostic-report-request';
      preLoaderRoute: typeof practitionerPractitionerQuickDiagnosticReportRequestImport;
      parentRoute: typeof practitionerRouteImport;
    };
    '/(practitioner)/practitioner/work-list': {
      id: '/(practitioner)/practitioner/work-list';
      path: '/practitioner/work-list';
      fullPath: '/practitioner/work-list';
      preLoaderRoute: typeof practitionerPractitionerWorkListImport;
      parentRoute: typeof practitionerRouteImport;
    };
    '/(public)/disable-emails/$token': {
      id: '/(public)/disable-emails/$token';
      path: '/disable-emails/$token';
      fullPath: '/disable-emails/$token';
      preLoaderRoute: typeof publicDisableEmailsTokenImport;
      parentRoute: typeof publicRouteImport;
    };
    '/(shared)/events/$eventId': {
      id: '/(shared)/events/$eventId';
      path: '/events/$eventId';
      fullPath: '/events/$eventId';
      preLoaderRoute: typeof sharedEventsEventIdImport;
      parentRoute: typeof sharedRouteImport;
    };
    '/(practitioner)/company/pathology-customization/create': {
      id: '/(practitioner)/company/pathology-customization/create';
      path: '/create';
      fullPath: '/company/pathology-customization/create';
      preLoaderRoute: typeof practitionerCompanyPathologyCustomizationCreateImport;
      parentRoute: typeof practitionerCompanyPathologyCustomizationImport;
    };
    '/(practitioner)/company/practitioners/$practitionerId': {
      id: '/(practitioner)/company/practitioners/$practitionerId';
      path: '/$practitionerId';
      fullPath: '/company/practitioners/$practitionerId';
      preLoaderRoute: typeof practitionerCompanyPractitionersPractitionerIdImport;
      parentRoute: typeof practitionerCompanyPractitionersImport;
    };
    '/(practitioner)/company/practitioners/create': {
      id: '/(practitioner)/company/practitioners/create';
      path: '/create';
      fullPath: '/company/practitioners/create';
      preLoaderRoute: typeof practitionerCompanyPractitionersCreateImport;
      parentRoute: typeof practitionerCompanyPractitionersImport;
    };
    '/(practitioner)/patients/$patientId/delete': {
      id: '/(practitioner)/patients/$patientId/delete';
      path: '/delete';
      fullPath: '/patients/$patientId/delete';
      preLoaderRoute: typeof practitionerPatientsPatientIdDeleteImport;
      parentRoute: typeof practitionerPatientsPatientIdImport;
    };
    '/(practitioner)/patients/$patientId/patient-interactions': {
      id: '/(practitioner)/patients/$patientId/patient-interactions';
      path: '/patient-interactions';
      fullPath: '/patients/$patientId/patient-interactions';
      preLoaderRoute: typeof practitionerPatientsPatientIdPatientInteractionsImport;
      parentRoute: typeof practitionerPatientsPatientIdImport;
    };
    '/(practitioner)/patients/$patientId/recover-password': {
      id: '/(practitioner)/patients/$patientId/recover-password';
      path: '/recover-password';
      fullPath: '/patients/$patientId/recover-password';
      preLoaderRoute: typeof practitionerPatientsPatientIdRecoverPasswordImport;
      parentRoute: typeof practitionerPatientsPatientIdImport;
    };
    '/(practitioner)/patients/$patientId/terminate-study': {
      id: '/(practitioner)/patients/$patientId/terminate-study';
      path: '/terminate-study';
      fullPath: '/patients/$patientId/terminate-study';
      preLoaderRoute: typeof practitionerPatientsPatientIdTerminateStudyImport;
      parentRoute: typeof practitionerPatientsPatientIdImport;
    };
    '/(practitioner)/practitioner/activity/$date': {
      id: '/(practitioner)/practitioner/activity/$date';
      path: '/$date';
      fullPath: '/practitioner/activity/$date';
      preLoaderRoute: typeof practitionerPractitionerActivityDateImport;
      parentRoute: typeof practitionerPractitionerActivityImport;
    };
    '/(practitioner)/practitioner/events/$eventId': {
      id: '/(practitioner)/practitioner/events/$eventId';
      path: '/practitioner/events/$eventId';
      fullPath: '/practitioner/events/$eventId';
      preLoaderRoute: typeof practitionerPractitionerEventsEventIdImport;
      parentRoute: typeof practitionerRouteImport;
    };
    '/(practitioner)/practitioner/events/create': {
      id: '/(practitioner)/practitioner/events/create';
      path: '/practitioner/events/create';
      fullPath: '/practitioner/events/create';
      preLoaderRoute: typeof practitionerPractitionerEventsCreateImport;
      parentRoute: typeof practitionerRouteImport;
    };
    '/(practitioner)/practitioner/medication-requests/create': {
      id: '/(practitioner)/practitioner/medication-requests/create';
      path: '/practitioner/medication-requests/create';
      fullPath: '/practitioner/medication-requests/create';
      preLoaderRoute: typeof practitionerPractitionerMedicationRequestsCreateImport;
      parentRoute: typeof practitionerRouteImport;
    };
    '/(practitioner)/practitioner/patient-payment-orders/create': {
      id: '/(practitioner)/practitioner/patient-payment-orders/create';
      path: '/create';
      fullPath: '/practitioner/patient-payment-orders/create';
      preLoaderRoute: typeof practitionerPractitionerPatientPaymentOrdersCreateImport;
      parentRoute: typeof practitionerPractitionerPatientPaymentOrdersImport;
    };
    '/(practitioner)/practitioners/$practitionerId/recover-password': {
      id: '/(practitioner)/practitioners/$practitionerId/recover-password';
      path: '/practitioners/$practitionerId/recover-password';
      fullPath: '/practitioners/$practitionerId/recover-password';
      preLoaderRoute: typeof practitionerPractitionersPractitionerIdRecoverPasswordImport;
      parentRoute: typeof practitionerRouteImport;
    };
    '/(shared)/medication-requests/$medicationRequestId/pdf': {
      id: '/(shared)/medication-requests/$medicationRequestId/pdf';
      path: '/medication-requests/$medicationRequestId/pdf';
      fullPath: '/medication-requests/$medicationRequestId/pdf';
      preLoaderRoute: typeof sharedMedicationRequestsMedicationRequestIdPdfImport;
      parentRoute: typeof sharedRouteImport;
    };
    '/(patient)/patient/payment-orders/$paymentOrderId/pay': {
      id: '/(patient)/patient/payment-orders/$paymentOrderId/pay';
      path: '/$paymentOrderId/pay';
      fullPath: '/patient/payment-orders/$paymentOrderId/pay';
      preLoaderRoute: typeof patientPatientPaymentOrdersPaymentOrderIdPayImport;
      parentRoute: typeof patientPatientPaymentOrdersImport;
    };
    '/(practitioner)/company/pathology-customization/$pathologyId/edit': {
      id: '/(practitioner)/company/pathology-customization/$pathologyId/edit';
      path: '/$pathologyId/edit';
      fullPath: '/company/pathology-customization/$pathologyId/edit';
      preLoaderRoute: typeof practitionerCompanyPathologyCustomizationPathologyIdEditImport;
      parentRoute: typeof practitionerCompanyPathologyCustomizationImport;
    };
    '/(practitioner)/company/pathology-overrides/$pathologyOverrideId/delete': {
      id: '/(practitioner)/company/pathology-overrides/$pathologyOverrideId/delete';
      path: '/pathology-overrides/$pathologyOverrideId/delete';
      fullPath: '/company/pathology-overrides/$pathologyOverrideId/delete';
      preLoaderRoute: typeof practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteImport;
      parentRoute: typeof practitionerCompanyImport;
    };
    '/(practitioner)/company/practitioners/$practitionerId/delete': {
      id: '/(practitioner)/company/practitioners/$practitionerId/delete';
      path: '/delete';
      fullPath: '/company/practitioners/$practitionerId/delete';
      preLoaderRoute: typeof practitionerCompanyPractitionersPractitionerIdDeleteImport;
      parentRoute: typeof practitionerCompanyPractitionersPractitionerIdImport;
    };
    '/(practitioner)/patients/$patientId/diagnostic-report/$diagnosticReportId': {
      id: '/(practitioner)/patients/$patientId/diagnostic-report/$diagnosticReportId';
      path: '/diagnostic-report/$diagnosticReportId';
      fullPath: '/patients/$patientId/diagnostic-report/$diagnosticReportId';
      preLoaderRoute: typeof practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdImport;
      parentRoute: typeof practitionerPatientsPatientIdImport;
    };
    '/(practitioner)/patients/$patientId/encounters/$encounterId': {
      id: '/(practitioner)/patients/$patientId/encounters/$encounterId';
      path: '/encounters/$encounterId';
      fullPath: '/patients/$patientId/encounters/$encounterId';
      preLoaderRoute: typeof practitionerPatientsPatientIdEncountersEncounterIdImport;
      parentRoute: typeof practitionerPatientsPatientIdImport;
    };
    '/(practitioner)/patients/$patientId/temporary-images/upload': {
      id: '/(practitioner)/patients/$patientId/temporary-images/upload';
      path: '/temporary-images/upload';
      fullPath: '/patients/$patientId/temporary-images/upload';
      preLoaderRoute: typeof practitionerPatientsPatientIdTemporaryImagesUploadImport;
      parentRoute: typeof practitionerPatientsPatientIdImport;
    };
    '/(practitioner)/practitioner/medication-requests/$medicationRequestId/delete': {
      id: '/(practitioner)/practitioner/medication-requests/$medicationRequestId/delete';
      path: '/practitioner/medication-requests/$medicationRequestId/delete';
      fullPath: '/practitioner/medication-requests/$medicationRequestId/delete';
      preLoaderRoute: typeof practitionerPractitionerMedicationRequestsMedicationRequestIdDeleteImport;
      parentRoute: typeof practitionerRouteImport;
    };
    '/(practitioner)/practitioner/medication-requests/$medicationRequestId/edit': {
      id: '/(practitioner)/practitioner/medication-requests/$medicationRequestId/edit';
      path: '/practitioner/medication-requests/$medicationRequestId/edit';
      fullPath: '/practitioner/medication-requests/$medicationRequestId/edit';
      preLoaderRoute: typeof practitionerPractitionerMedicationRequestsMedicationRequestIdEditImport;
      parentRoute: typeof practitionerRouteImport;
    };
  }
}

// Create and export the route tree

interface anonymousRouteRouteChildren {
  anonymousAppHomeRoute: typeof anonymousAppHomeRoute;
  anonymousConfirmRoute: typeof anonymousConfirmRoute;
  anonymousConfirmAccountRoute: typeof anonymousConfirmAccountRoute;
  anonymousLoginRoute: typeof anonymousLoginRoute;
  anonymousPatientSignupRoute: typeof anonymousPatientSignupRoute;
  anonymousRecoverPasswordRoute: typeof anonymousRecoverPasswordRoute;
  anonymousRegisterRoute: typeof anonymousRegisterRoute;
  anonymousResetPasswordRoute: typeof anonymousResetPasswordRoute;
}

const anonymousRouteRouteChildren: anonymousRouteRouteChildren = {
  anonymousAppHomeRoute: anonymousAppHomeRoute,
  anonymousConfirmRoute: anonymousConfirmRoute,
  anonymousConfirmAccountRoute: anonymousConfirmAccountRoute,
  anonymousLoginRoute: anonymousLoginRoute,
  anonymousPatientSignupRoute: anonymousPatientSignupRoute,
  anonymousRecoverPasswordRoute: anonymousRecoverPasswordRoute,
  anonymousRegisterRoute: anonymousRegisterRoute,
  anonymousResetPasswordRoute: anonymousResetPasswordRoute
};

const anonymousRouteRouteWithChildren = anonymousRouteRoute._addFileChildren(
  anonymousRouteRouteChildren
);

interface patientDiagnosticReportsRouteChildren {
  patientDiagnosticReportsDiagnosticReportIdRoute: typeof patientDiagnosticReportsDiagnosticReportIdRoute;
}

const patientDiagnosticReportsRouteChildren: patientDiagnosticReportsRouteChildren = {
  patientDiagnosticReportsDiagnosticReportIdRoute: patientDiagnosticReportsDiagnosticReportIdRoute
};

const patientDiagnosticReportsRouteWithChildren = patientDiagnosticReportsRoute._addFileChildren(
  patientDiagnosticReportsRouteChildren
);

interface patientDocumentsRouteChildren {
  patientDocumentsCreateRoute: typeof patientDocumentsCreateRoute;
}

const patientDocumentsRouteChildren: patientDocumentsRouteChildren = {
  patientDocumentsCreateRoute: patientDocumentsCreateRoute
};

const patientDocumentsRouteWithChildren = patientDocumentsRoute._addFileChildren(
  patientDocumentsRouteChildren
);

interface patientPatientPaymentOrdersRouteChildren {
  patientPatientPaymentOrdersPaymentOrderIdPayRoute: typeof patientPatientPaymentOrdersPaymentOrderIdPayRoute;
}

const patientPatientPaymentOrdersRouteChildren: patientPatientPaymentOrdersRouteChildren = {
  patientPatientPaymentOrdersPaymentOrderIdPayRoute:
    patientPatientPaymentOrdersPaymentOrderIdPayRoute
};

const patientPatientPaymentOrdersRouteWithChildren =
  patientPatientPaymentOrdersRoute._addFileChildren(patientPatientPaymentOrdersRouteChildren);

interface patientRouteRouteChildren {
  patientDiagnosticReportsRoute: typeof patientDiagnosticReportsRouteWithChildren;
  patientDocumentsRoute: typeof patientDocumentsRouteWithChildren;
  patientEncountersRoute: typeof patientEncountersRoute;
  patientEventsRoute: typeof patientEventsRoute;
  patientGlobalDiagnosticReportsRoute: typeof patientGlobalDiagnosticReportsRoute;
  patientMedicationRequestsRoute: typeof patientMedicationRequestsRoute;
  patientPatientDiagnosticReportRequestRoute: typeof patientPatientDiagnosticReportRequestRoute;
  patientPatientDiagnosticReportSentRoute: typeof patientPatientDiagnosticReportSentRoute;
  patientPatientPaymentOrdersRoute: typeof patientPatientPaymentOrdersRouteWithChildren;
  patientPatientPsoriasisInfoRoute: typeof patientPatientPsoriasisInfoRoute;
}

const patientRouteRouteChildren: patientRouteRouteChildren = {
  patientDiagnosticReportsRoute: patientDiagnosticReportsRouteWithChildren,
  patientDocumentsRoute: patientDocumentsRouteWithChildren,
  patientEncountersRoute: patientEncountersRoute,
  patientEventsRoute: patientEventsRoute,
  patientGlobalDiagnosticReportsRoute: patientGlobalDiagnosticReportsRoute,
  patientMedicationRequestsRoute: patientMedicationRequestsRoute,
  patientPatientDiagnosticReportRequestRoute: patientPatientDiagnosticReportRequestRoute,
  patientPatientDiagnosticReportSentRoute: patientPatientDiagnosticReportSentRoute,
  patientPatientPaymentOrdersRoute: patientPatientPaymentOrdersRouteWithChildren,
  patientPatientPsoriasisInfoRoute: patientPatientPsoriasisInfoRoute
};

const patientRouteRouteWithChildren = patientRouteRoute._addFileChildren(patientRouteRouteChildren);

interface practitionerCompanyPathologyCustomizationRouteChildren {
  practitionerCompanyPathologyCustomizationCreateRoute: typeof practitionerCompanyPathologyCustomizationCreateRoute;
  practitionerCompanyPathologyCustomizationPathologyIdEditRoute: typeof practitionerCompanyPathologyCustomizationPathologyIdEditRoute;
}

const practitionerCompanyPathologyCustomizationRouteChildren: practitionerCompanyPathologyCustomizationRouteChildren =
  {
    practitionerCompanyPathologyCustomizationCreateRoute:
      practitionerCompanyPathologyCustomizationCreateRoute,
    practitionerCompanyPathologyCustomizationPathologyIdEditRoute:
      practitionerCompanyPathologyCustomizationPathologyIdEditRoute
  };

const practitionerCompanyPathologyCustomizationRouteWithChildren =
  practitionerCompanyPathologyCustomizationRoute._addFileChildren(
    practitionerCompanyPathologyCustomizationRouteChildren
  );

interface practitionerCompanyPractitionersPractitionerIdRouteChildren {
  practitionerCompanyPractitionersPractitionerIdDeleteRoute: typeof practitionerCompanyPractitionersPractitionerIdDeleteRoute;
}

const practitionerCompanyPractitionersPractitionerIdRouteChildren: practitionerCompanyPractitionersPractitionerIdRouteChildren =
  {
    practitionerCompanyPractitionersPractitionerIdDeleteRoute:
      practitionerCompanyPractitionersPractitionerIdDeleteRoute
  };

const practitionerCompanyPractitionersPractitionerIdRouteWithChildren =
  practitionerCompanyPractitionersPractitionerIdRoute._addFileChildren(
    practitionerCompanyPractitionersPractitionerIdRouteChildren
  );

interface practitionerCompanyPractitionersRouteChildren {
  practitionerCompanyPractitionersPractitionerIdRoute: typeof practitionerCompanyPractitionersPractitionerIdRouteWithChildren;
  practitionerCompanyPractitionersCreateRoute: typeof practitionerCompanyPractitionersCreateRoute;
}

const practitionerCompanyPractitionersRouteChildren: practitionerCompanyPractitionersRouteChildren =
  {
    practitionerCompanyPractitionersPractitionerIdRoute:
      practitionerCompanyPractitionersPractitionerIdRouteWithChildren,
    practitionerCompanyPractitionersCreateRoute: practitionerCompanyPractitionersCreateRoute
  };

const practitionerCompanyPractitionersRouteWithChildren =
  practitionerCompanyPractitionersRoute._addFileChildren(
    practitionerCompanyPractitionersRouteChildren
  );

interface practitionerCompanyRouteChildren {
  practitionerCompanyInactiveCompanyRoute: typeof practitionerCompanyInactiveCompanyRoute;
  practitionerCompanyMetricsRoute: typeof practitionerCompanyMetricsRoute;
  practitionerCompanyPathologyCustomizationRoute: typeof practitionerCompanyPathologyCustomizationRouteWithChildren;
  practitionerCompanyPractitionersRoute: typeof practitionerCompanyPractitionersRouteWithChildren;
  practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRoute: typeof practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRoute;
}

const practitionerCompanyRouteChildren: practitionerCompanyRouteChildren = {
  practitionerCompanyInactiveCompanyRoute: practitionerCompanyInactiveCompanyRoute,
  practitionerCompanyMetricsRoute: practitionerCompanyMetricsRoute,
  practitionerCompanyPathologyCustomizationRoute:
    practitionerCompanyPathologyCustomizationRouteWithChildren,
  practitionerCompanyPractitionersRoute: practitionerCompanyPractitionersRouteWithChildren,
  practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRoute:
    practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRoute
};

const practitionerCompanyRouteWithChildren = practitionerCompanyRoute._addFileChildren(
  practitionerCompanyRouteChildren
);

interface practitionerPatientsPatientIdRouteChildren {
  practitionerPatientsPatientIdDeleteRoute: typeof practitionerPatientsPatientIdDeleteRoute;
  practitionerPatientsPatientIdPatientInteractionsRoute: typeof practitionerPatientsPatientIdPatientInteractionsRoute;
  practitionerPatientsPatientIdRecoverPasswordRoute: typeof practitionerPatientsPatientIdRecoverPasswordRoute;
  practitionerPatientsPatientIdTerminateStudyRoute: typeof practitionerPatientsPatientIdTerminateStudyRoute;
  practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRoute: typeof practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRoute;
  practitionerPatientsPatientIdEncountersEncounterIdRoute: typeof practitionerPatientsPatientIdEncountersEncounterIdRoute;
  practitionerPatientsPatientIdTemporaryImagesUploadRoute: typeof practitionerPatientsPatientIdTemporaryImagesUploadRoute;
}

const practitionerPatientsPatientIdRouteChildren: practitionerPatientsPatientIdRouteChildren = {
  practitionerPatientsPatientIdDeleteRoute: practitionerPatientsPatientIdDeleteRoute,
  practitionerPatientsPatientIdPatientInteractionsRoute:
    practitionerPatientsPatientIdPatientInteractionsRoute,
  practitionerPatientsPatientIdRecoverPasswordRoute:
    practitionerPatientsPatientIdRecoverPasswordRoute,
  practitionerPatientsPatientIdTerminateStudyRoute:
    practitionerPatientsPatientIdTerminateStudyRoute,
  practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRoute:
    practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRoute,
  practitionerPatientsPatientIdEncountersEncounterIdRoute:
    practitionerPatientsPatientIdEncountersEncounterIdRoute,
  practitionerPatientsPatientIdTemporaryImagesUploadRoute:
    practitionerPatientsPatientIdTemporaryImagesUploadRoute
};

const practitionerPatientsPatientIdRouteWithChildren =
  practitionerPatientsPatientIdRoute._addFileChildren(practitionerPatientsPatientIdRouteChildren);

interface practitionerPatientsRouteChildren {
  practitionerPatientsPatientIdRoute: typeof practitionerPatientsPatientIdRouteWithChildren;
  practitionerPatientsCreateRoute: typeof practitionerPatientsCreateRoute;
}

const practitionerPatientsRouteChildren: practitionerPatientsRouteChildren = {
  practitionerPatientsPatientIdRoute: practitionerPatientsPatientIdRouteWithChildren,
  practitionerPatientsCreateRoute: practitionerPatientsCreateRoute
};

const practitionerPatientsRouteWithChildren = practitionerPatientsRoute._addFileChildren(
  practitionerPatientsRouteChildren
);

interface practitionerPractitionerActivityRouteChildren {
  practitionerPractitionerActivityDateRoute: typeof practitionerPractitionerActivityDateRoute;
}

const practitionerPractitionerActivityRouteChildren: practitionerPractitionerActivityRouteChildren =
  {
    practitionerPractitionerActivityDateRoute: practitionerPractitionerActivityDateRoute
  };

const practitionerPractitionerActivityRouteWithChildren =
  practitionerPractitionerActivityRoute._addFileChildren(
    practitionerPractitionerActivityRouteChildren
  );

interface practitionerPractitionerPatientPaymentOrdersRouteChildren {
  practitionerPractitionerPatientPaymentOrdersCreateRoute: typeof practitionerPractitionerPatientPaymentOrdersCreateRoute;
}

const practitionerPractitionerPatientPaymentOrdersRouteChildren: practitionerPractitionerPatientPaymentOrdersRouteChildren =
  {
    practitionerPractitionerPatientPaymentOrdersCreateRoute:
      practitionerPractitionerPatientPaymentOrdersCreateRoute
  };

const practitionerPractitionerPatientPaymentOrdersRouteWithChildren =
  practitionerPractitionerPatientPaymentOrdersRoute._addFileChildren(
    practitionerPractitionerPatientPaymentOrdersRouteChildren
  );

interface practitionerRouteRouteChildren {
  practitionerCompanyRoute: typeof practitionerCompanyRouteWithChildren;
  practitionerDiagnosticReportsRoute: typeof practitionerDiagnosticReportsRoute;
  practitionerPatientsRoute: typeof practitionerPatientsRouteWithChildren;
  practitionerPractitionerActivityRoute: typeof practitionerPractitionerActivityRouteWithChildren;
  practitionerPractitionerDiagnosticReportRequestRoute: typeof practitionerPractitionerDiagnosticReportRequestRoute;
  practitionerPractitionerDiagnosticReportSentRoute: typeof practitionerPractitionerDiagnosticReportSentRoute;
  practitionerPractitionerPatientPaymentOrdersRoute: typeof practitionerPractitionerPatientPaymentOrdersRouteWithChildren;
  practitionerPractitionerQuickDiagnosticReportRequestRoute: typeof practitionerPractitionerQuickDiagnosticReportRequestRoute;
  practitionerPractitionerWorkListRoute: typeof practitionerPractitionerWorkListRoute;
  practitionerPractitionerEventsEventIdRoute: typeof practitionerPractitionerEventsEventIdRoute;
  practitionerPractitionerEventsCreateRoute: typeof practitionerPractitionerEventsCreateRoute;
  practitionerPractitionerMedicationRequestsCreateRoute: typeof practitionerPractitionerMedicationRequestsCreateRoute;
  practitionerPractitionersPractitionerIdRecoverPasswordRoute: typeof practitionerPractitionersPractitionerIdRecoverPasswordRoute;
  practitionerPractitionerMedicationRequestsMedicationRequestIdDeleteRoute: typeof practitionerPractitionerMedicationRequestsMedicationRequestIdDeleteRoute;
  practitionerPractitionerMedicationRequestsMedicationRequestIdEditRoute: typeof practitionerPractitionerMedicationRequestsMedicationRequestIdEditRoute;
}

const practitionerRouteRouteChildren: practitionerRouteRouteChildren = {
  practitionerCompanyRoute: practitionerCompanyRouteWithChildren,
  practitionerDiagnosticReportsRoute: practitionerDiagnosticReportsRoute,
  practitionerPatientsRoute: practitionerPatientsRouteWithChildren,
  practitionerPractitionerActivityRoute: practitionerPractitionerActivityRouteWithChildren,
  practitionerPractitionerDiagnosticReportRequestRoute:
    practitionerPractitionerDiagnosticReportRequestRoute,
  practitionerPractitionerDiagnosticReportSentRoute:
    practitionerPractitionerDiagnosticReportSentRoute,
  practitionerPractitionerPatientPaymentOrdersRoute:
    practitionerPractitionerPatientPaymentOrdersRouteWithChildren,
  practitionerPractitionerQuickDiagnosticReportRequestRoute:
    practitionerPractitionerQuickDiagnosticReportRequestRoute,
  practitionerPractitionerWorkListRoute: practitionerPractitionerWorkListRoute,
  practitionerPractitionerEventsEventIdRoute: practitionerPractitionerEventsEventIdRoute,
  practitionerPractitionerEventsCreateRoute: practitionerPractitionerEventsCreateRoute,
  practitionerPractitionerMedicationRequestsCreateRoute:
    practitionerPractitionerMedicationRequestsCreateRoute,
  practitionerPractitionersPractitionerIdRecoverPasswordRoute:
    practitionerPractitionersPractitionerIdRecoverPasswordRoute,
  practitionerPractitionerMedicationRequestsMedicationRequestIdDeleteRoute:
    practitionerPractitionerMedicationRequestsMedicationRequestIdDeleteRoute,
  practitionerPractitionerMedicationRequestsMedicationRequestIdEditRoute:
    practitionerPractitionerMedicationRequestsMedicationRequestIdEditRoute
};

const practitionerRouteRouteWithChildren = practitionerRouteRoute._addFileChildren(
  practitionerRouteRouteChildren
);

interface publicRouteRouteChildren {
  publicLegalRoute: typeof publicLegalRoute;
  publicSupportRoute: typeof publicSupportRoute;
  publicDisableEmailsTokenRoute: typeof publicDisableEmailsTokenRoute;
}

const publicRouteRouteChildren: publicRouteRouteChildren = {
  publicLegalRoute: publicLegalRoute,
  publicSupportRoute: publicSupportRoute,
  publicDisableEmailsTokenRoute: publicDisableEmailsTokenRoute
};

const publicRouteRouteWithChildren = publicRouteRoute._addFileChildren(publicRouteRouteChildren);

interface sharedRouteRouteChildren {
  sharedAuditLogRoute: typeof sharedAuditLogRoute;
  sharedBackupRoute: typeof sharedBackupRoute;
  sharedContactRoute: typeof sharedContactRoute;
  sharedHomeRoute: typeof sharedHomeRoute;
  sharedLogoutRoute: typeof sharedLogoutRoute;
  sharedNotificationsRoute: typeof sharedNotificationsRoute;
  sharedProfileRoute: typeof sharedProfileRoute;
  sharedEventsEventIdRoute: typeof sharedEventsEventIdRoute;
  sharedMedicationRequestsMedicationRequestIdPdfRoute: typeof sharedMedicationRequestsMedicationRequestIdPdfRoute;
}

const sharedRouteRouteChildren: sharedRouteRouteChildren = {
  sharedAuditLogRoute: sharedAuditLogRoute,
  sharedBackupRoute: sharedBackupRoute,
  sharedContactRoute: sharedContactRoute,
  sharedHomeRoute: sharedHomeRoute,
  sharedLogoutRoute: sharedLogoutRoute,
  sharedNotificationsRoute: sharedNotificationsRoute,
  sharedProfileRoute: sharedProfileRoute,
  sharedEventsEventIdRoute: sharedEventsEventIdRoute,
  sharedMedicationRequestsMedicationRequestIdPdfRoute:
    sharedMedicationRequestsMedicationRequestIdPdfRoute
};

const sharedRouteRouteWithChildren = sharedRouteRoute._addFileChildren(sharedRouteRouteChildren);

export interface FileRoutesByFullPath {
  '/': typeof sharedRouteRouteWithChildren;
  '/app-home': typeof anonymousAppHomeRoute;
  '/confirm': typeof anonymousConfirmRoute;
  '/confirm-account': typeof anonymousConfirmAccountRoute;
  '/login': typeof anonymousLoginRoute;
  '/patient-signup': typeof anonymousPatientSignupRoute;
  '/recover-password': typeof anonymousRecoverPasswordRoute;
  '/register': typeof anonymousRegisterRoute;
  '/reset-password': typeof anonymousResetPasswordRoute;
  '/diagnostic-reports': typeof practitionerDiagnosticReportsRoute;
  '/documents': typeof patientDocumentsRouteWithChildren;
  '/encounters': typeof patientEncountersRoute;
  '/events': typeof patientEventsRoute;
  '/global-diagnostic-reports': typeof patientGlobalDiagnosticReportsRoute;
  '/medication-requests': typeof patientMedicationRequestsRoute;
  '/company': typeof practitionerCompanyRouteWithChildren;
  '/patients': typeof practitionerPatientsRouteWithChildren;
  '/legal': typeof publicLegalRoute;
  '/support': typeof publicSupportRoute;
  '/audit-log': typeof sharedAuditLogRoute;
  '/backup': typeof sharedBackupRoute;
  '/contact': typeof sharedContactRoute;
  '/home': typeof sharedHomeRoute;
  '/logout': typeof sharedLogoutRoute;
  '/notifications': typeof sharedNotificationsRoute;
  '/profile': typeof sharedProfileRoute;
  '/diagnostic-reports/$diagnosticReportId': typeof patientDiagnosticReportsDiagnosticReportIdRoute;
  '/documents/create': typeof patientDocumentsCreateRoute;
  '/patient/diagnostic-report-request': typeof patientPatientDiagnosticReportRequestRoute;
  '/patient/diagnostic-report-sent': typeof patientPatientDiagnosticReportSentRoute;
  '/patient/payment-orders': typeof patientPatientPaymentOrdersRouteWithChildren;
  '/patient/psoriasis-info': typeof patientPatientPsoriasisInfoRoute;
  '/company/inactive-company': typeof practitionerCompanyInactiveCompanyRoute;
  '/company/metrics': typeof practitionerCompanyMetricsRoute;
  '/company/pathology-customization': typeof practitionerCompanyPathologyCustomizationRouteWithChildren;
  '/company/practitioners': typeof practitionerCompanyPractitionersRouteWithChildren;
  '/patients/$patientId': typeof practitionerPatientsPatientIdRouteWithChildren;
  '/patients/create': typeof practitionerPatientsCreateRoute;
  '/practitioner/activity': typeof practitionerPractitionerActivityRouteWithChildren;
  '/practitioner/diagnostic-report-request': typeof practitionerPractitionerDiagnosticReportRequestRoute;
  '/practitioner/diagnostic-report-sent': typeof practitionerPractitionerDiagnosticReportSentRoute;
  '/practitioner/patient-payment-orders': typeof practitionerPractitionerPatientPaymentOrdersRouteWithChildren;
  '/practitioner/quick-diagnostic-report-request': typeof practitionerPractitionerQuickDiagnosticReportRequestRoute;
  '/practitioner/work-list': typeof practitionerPractitionerWorkListRoute;
  '/disable-emails/$token': typeof publicDisableEmailsTokenRoute;
  '/events/$eventId': typeof sharedEventsEventIdRoute;
  '/company/pathology-customization/create': typeof practitionerCompanyPathologyCustomizationCreateRoute;
  '/company/practitioners/$practitionerId': typeof practitionerCompanyPractitionersPractitionerIdRouteWithChildren;
  '/company/practitioners/create': typeof practitionerCompanyPractitionersCreateRoute;
  '/patients/$patientId/delete': typeof practitionerPatientsPatientIdDeleteRoute;
  '/patients/$patientId/patient-interactions': typeof practitionerPatientsPatientIdPatientInteractionsRoute;
  '/patients/$patientId/recover-password': typeof practitionerPatientsPatientIdRecoverPasswordRoute;
  '/patients/$patientId/terminate-study': typeof practitionerPatientsPatientIdTerminateStudyRoute;
  '/practitioner/activity/$date': typeof practitionerPractitionerActivityDateRoute;
  '/practitioner/events/$eventId': typeof practitionerPractitionerEventsEventIdRoute;
  '/practitioner/events/create': typeof practitionerPractitionerEventsCreateRoute;
  '/practitioner/medication-requests/create': typeof practitionerPractitionerMedicationRequestsCreateRoute;
  '/practitioner/patient-payment-orders/create': typeof practitionerPractitionerPatientPaymentOrdersCreateRoute;
  '/practitioners/$practitionerId/recover-password': typeof practitionerPractitionersPractitionerIdRecoverPasswordRoute;
  '/medication-requests/$medicationRequestId/pdf': typeof sharedMedicationRequestsMedicationRequestIdPdfRoute;
  '/patient/payment-orders/$paymentOrderId/pay': typeof patientPatientPaymentOrdersPaymentOrderIdPayRoute;
  '/company/pathology-customization/$pathologyId/edit': typeof practitionerCompanyPathologyCustomizationPathologyIdEditRoute;
  '/company/pathology-overrides/$pathologyOverrideId/delete': typeof practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRoute;
  '/company/practitioners/$practitionerId/delete': typeof practitionerCompanyPractitionersPractitionerIdDeleteRoute;
  '/patients/$patientId/diagnostic-report/$diagnosticReportId': typeof practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRoute;
  '/patients/$patientId/encounters/$encounterId': typeof practitionerPatientsPatientIdEncountersEncounterIdRoute;
  '/patients/$patientId/temporary-images/upload': typeof practitionerPatientsPatientIdTemporaryImagesUploadRoute;
  '/practitioner/medication-requests/$medicationRequestId/delete': typeof practitionerPractitionerMedicationRequestsMedicationRequestIdDeleteRoute;
  '/practitioner/medication-requests/$medicationRequestId/edit': typeof practitionerPractitionerMedicationRequestsMedicationRequestIdEditRoute;
}

export interface FileRoutesByTo {
  '/': typeof sharedRouteRouteWithChildren;
  '/app-home': typeof anonymousAppHomeRoute;
  '/confirm': typeof anonymousConfirmRoute;
  '/confirm-account': typeof anonymousConfirmAccountRoute;
  '/login': typeof anonymousLoginRoute;
  '/patient-signup': typeof anonymousPatientSignupRoute;
  '/recover-password': typeof anonymousRecoverPasswordRoute;
  '/register': typeof anonymousRegisterRoute;
  '/reset-password': typeof anonymousResetPasswordRoute;
  '/diagnostic-reports': typeof practitionerDiagnosticReportsRoute;
  '/documents': typeof patientDocumentsRouteWithChildren;
  '/encounters': typeof patientEncountersRoute;
  '/events': typeof patientEventsRoute;
  '/global-diagnostic-reports': typeof patientGlobalDiagnosticReportsRoute;
  '/medication-requests': typeof patientMedicationRequestsRoute;
  '/company': typeof practitionerCompanyRouteWithChildren;
  '/patients': typeof practitionerPatientsRouteWithChildren;
  '/legal': typeof publicLegalRoute;
  '/support': typeof publicSupportRoute;
  '/audit-log': typeof sharedAuditLogRoute;
  '/backup': typeof sharedBackupRoute;
  '/contact': typeof sharedContactRoute;
  '/home': typeof sharedHomeRoute;
  '/logout': typeof sharedLogoutRoute;
  '/notifications': typeof sharedNotificationsRoute;
  '/profile': typeof sharedProfileRoute;
  '/diagnostic-reports/$diagnosticReportId': typeof patientDiagnosticReportsDiagnosticReportIdRoute;
  '/documents/create': typeof patientDocumentsCreateRoute;
  '/patient/diagnostic-report-request': typeof patientPatientDiagnosticReportRequestRoute;
  '/patient/diagnostic-report-sent': typeof patientPatientDiagnosticReportSentRoute;
  '/patient/payment-orders': typeof patientPatientPaymentOrdersRouteWithChildren;
  '/patient/psoriasis-info': typeof patientPatientPsoriasisInfoRoute;
  '/company/inactive-company': typeof practitionerCompanyInactiveCompanyRoute;
  '/company/metrics': typeof practitionerCompanyMetricsRoute;
  '/company/pathology-customization': typeof practitionerCompanyPathologyCustomizationRouteWithChildren;
  '/company/practitioners': typeof practitionerCompanyPractitionersRouteWithChildren;
  '/patients/$patientId': typeof practitionerPatientsPatientIdRouteWithChildren;
  '/patients/create': typeof practitionerPatientsCreateRoute;
  '/practitioner/activity': typeof practitionerPractitionerActivityRouteWithChildren;
  '/practitioner/diagnostic-report-request': typeof practitionerPractitionerDiagnosticReportRequestRoute;
  '/practitioner/diagnostic-report-sent': typeof practitionerPractitionerDiagnosticReportSentRoute;
  '/practitioner/patient-payment-orders': typeof practitionerPractitionerPatientPaymentOrdersRouteWithChildren;
  '/practitioner/quick-diagnostic-report-request': typeof practitionerPractitionerQuickDiagnosticReportRequestRoute;
  '/practitioner/work-list': typeof practitionerPractitionerWorkListRoute;
  '/disable-emails/$token': typeof publicDisableEmailsTokenRoute;
  '/events/$eventId': typeof sharedEventsEventIdRoute;
  '/company/pathology-customization/create': typeof practitionerCompanyPathologyCustomizationCreateRoute;
  '/company/practitioners/$practitionerId': typeof practitionerCompanyPractitionersPractitionerIdRouteWithChildren;
  '/company/practitioners/create': typeof practitionerCompanyPractitionersCreateRoute;
  '/patients/$patientId/delete': typeof practitionerPatientsPatientIdDeleteRoute;
  '/patients/$patientId/patient-interactions': typeof practitionerPatientsPatientIdPatientInteractionsRoute;
  '/patients/$patientId/recover-password': typeof practitionerPatientsPatientIdRecoverPasswordRoute;
  '/patients/$patientId/terminate-study': typeof practitionerPatientsPatientIdTerminateStudyRoute;
  '/practitioner/activity/$date': typeof practitionerPractitionerActivityDateRoute;
  '/practitioner/events/$eventId': typeof practitionerPractitionerEventsEventIdRoute;
  '/practitioner/events/create': typeof practitionerPractitionerEventsCreateRoute;
  '/practitioner/medication-requests/create': typeof practitionerPractitionerMedicationRequestsCreateRoute;
  '/practitioner/patient-payment-orders/create': typeof practitionerPractitionerPatientPaymentOrdersCreateRoute;
  '/practitioners/$practitionerId/recover-password': typeof practitionerPractitionersPractitionerIdRecoverPasswordRoute;
  '/medication-requests/$medicationRequestId/pdf': typeof sharedMedicationRequestsMedicationRequestIdPdfRoute;
  '/patient/payment-orders/$paymentOrderId/pay': typeof patientPatientPaymentOrdersPaymentOrderIdPayRoute;
  '/company/pathology-customization/$pathologyId/edit': typeof practitionerCompanyPathologyCustomizationPathologyIdEditRoute;
  '/company/pathology-overrides/$pathologyOverrideId/delete': typeof practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRoute;
  '/company/practitioners/$practitionerId/delete': typeof practitionerCompanyPractitionersPractitionerIdDeleteRoute;
  '/patients/$patientId/diagnostic-report/$diagnosticReportId': typeof practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRoute;
  '/patients/$patientId/encounters/$encounterId': typeof practitionerPatientsPatientIdEncountersEncounterIdRoute;
  '/patients/$patientId/temporary-images/upload': typeof practitionerPatientsPatientIdTemporaryImagesUploadRoute;
  '/practitioner/medication-requests/$medicationRequestId/delete': typeof practitionerPractitionerMedicationRequestsMedicationRequestIdDeleteRoute;
  '/practitioner/medication-requests/$medicationRequestId/edit': typeof practitionerPractitionerMedicationRequestsMedicationRequestIdEditRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  '/(anonymous)': typeof anonymousRouteRouteWithChildren;
  '/(patient)': typeof patientRouteRouteWithChildren;
  '/(practitioner)': typeof practitionerRouteRouteWithChildren;
  '/(public)': typeof publicRouteRouteWithChildren;
  '/(shared)': typeof sharedRouteRouteWithChildren;
  '/(anonymous)/app-home': typeof anonymousAppHomeRoute;
  '/(anonymous)/confirm': typeof anonymousConfirmRoute;
  '/(anonymous)/confirm-account': typeof anonymousConfirmAccountRoute;
  '/(anonymous)/login': typeof anonymousLoginRoute;
  '/(anonymous)/patient-signup': typeof anonymousPatientSignupRoute;
  '/(anonymous)/recover-password': typeof anonymousRecoverPasswordRoute;
  '/(anonymous)/register': typeof anonymousRegisterRoute;
  '/(anonymous)/reset-password': typeof anonymousResetPasswordRoute;
  '/(patient)/diagnostic-reports': typeof patientDiagnosticReportsRouteWithChildren;
  '/(patient)/documents': typeof patientDocumentsRouteWithChildren;
  '/(patient)/encounters': typeof patientEncountersRoute;
  '/(patient)/events': typeof patientEventsRoute;
  '/(patient)/global-diagnostic-reports': typeof patientGlobalDiagnosticReportsRoute;
  '/(patient)/medication-requests': typeof patientMedicationRequestsRoute;
  '/(practitioner)/company': typeof practitionerCompanyRouteWithChildren;
  '/(practitioner)/diagnostic-reports': typeof practitionerDiagnosticReportsRoute;
  '/(practitioner)/patients': typeof practitionerPatientsRouteWithChildren;
  '/(public)/legal': typeof publicLegalRoute;
  '/(public)/support': typeof publicSupportRoute;
  '/(shared)/audit-log': typeof sharedAuditLogRoute;
  '/(shared)/backup': typeof sharedBackupRoute;
  '/(shared)/contact': typeof sharedContactRoute;
  '/(shared)/home': typeof sharedHomeRoute;
  '/(shared)/logout': typeof sharedLogoutRoute;
  '/(shared)/notifications': typeof sharedNotificationsRoute;
  '/(shared)/profile': typeof sharedProfileRoute;
  '/(patient)/diagnostic-reports/$diagnosticReportId': typeof patientDiagnosticReportsDiagnosticReportIdRoute;
  '/(patient)/documents/create': typeof patientDocumentsCreateRoute;
  '/(patient)/patient/diagnostic-report-request': typeof patientPatientDiagnosticReportRequestRoute;
  '/(patient)/patient/diagnostic-report-sent': typeof patientPatientDiagnosticReportSentRoute;
  '/(patient)/patient/payment-orders': typeof patientPatientPaymentOrdersRouteWithChildren;
  '/(patient)/patient/psoriasis-info': typeof patientPatientPsoriasisInfoRoute;
  '/(practitioner)/company/inactive-company': typeof practitionerCompanyInactiveCompanyRoute;
  '/(practitioner)/company/metrics': typeof practitionerCompanyMetricsRoute;
  '/(practitioner)/company/pathology-customization': typeof practitionerCompanyPathologyCustomizationRouteWithChildren;
  '/(practitioner)/company/practitioners': typeof practitionerCompanyPractitionersRouteWithChildren;
  '/(practitioner)/patients/$patientId': typeof practitionerPatientsPatientIdRouteWithChildren;
  '/(practitioner)/patients/create': typeof practitionerPatientsCreateRoute;
  '/(practitioner)/practitioner/activity': typeof practitionerPractitionerActivityRouteWithChildren;
  '/(practitioner)/practitioner/diagnostic-report-request': typeof practitionerPractitionerDiagnosticReportRequestRoute;
  '/(practitioner)/practitioner/diagnostic-report-sent': typeof practitionerPractitionerDiagnosticReportSentRoute;
  '/(practitioner)/practitioner/patient-payment-orders': typeof practitionerPractitionerPatientPaymentOrdersRouteWithChildren;
  '/(practitioner)/practitioner/quick-diagnostic-report-request': typeof practitionerPractitionerQuickDiagnosticReportRequestRoute;
  '/(practitioner)/practitioner/work-list': typeof practitionerPractitionerWorkListRoute;
  '/(public)/disable-emails/$token': typeof publicDisableEmailsTokenRoute;
  '/(shared)/events/$eventId': typeof sharedEventsEventIdRoute;
  '/(practitioner)/company/pathology-customization/create': typeof practitionerCompanyPathologyCustomizationCreateRoute;
  '/(practitioner)/company/practitioners/$practitionerId': typeof practitionerCompanyPractitionersPractitionerIdRouteWithChildren;
  '/(practitioner)/company/practitioners/create': typeof practitionerCompanyPractitionersCreateRoute;
  '/(practitioner)/patients/$patientId/delete': typeof practitionerPatientsPatientIdDeleteRoute;
  '/(practitioner)/patients/$patientId/patient-interactions': typeof practitionerPatientsPatientIdPatientInteractionsRoute;
  '/(practitioner)/patients/$patientId/recover-password': typeof practitionerPatientsPatientIdRecoverPasswordRoute;
  '/(practitioner)/patients/$patientId/terminate-study': typeof practitionerPatientsPatientIdTerminateStudyRoute;
  '/(practitioner)/practitioner/activity/$date': typeof practitionerPractitionerActivityDateRoute;
  '/(practitioner)/practitioner/events/$eventId': typeof practitionerPractitionerEventsEventIdRoute;
  '/(practitioner)/practitioner/events/create': typeof practitionerPractitionerEventsCreateRoute;
  '/(practitioner)/practitioner/medication-requests/create': typeof practitionerPractitionerMedicationRequestsCreateRoute;
  '/(practitioner)/practitioner/patient-payment-orders/create': typeof practitionerPractitionerPatientPaymentOrdersCreateRoute;
  '/(practitioner)/practitioners/$practitionerId/recover-password': typeof practitionerPractitionersPractitionerIdRecoverPasswordRoute;
  '/(shared)/medication-requests/$medicationRequestId/pdf': typeof sharedMedicationRequestsMedicationRequestIdPdfRoute;
  '/(patient)/patient/payment-orders/$paymentOrderId/pay': typeof patientPatientPaymentOrdersPaymentOrderIdPayRoute;
  '/(practitioner)/company/pathology-customization/$pathologyId/edit': typeof practitionerCompanyPathologyCustomizationPathologyIdEditRoute;
  '/(practitioner)/company/pathology-overrides/$pathologyOverrideId/delete': typeof practitionerCompanyPathologyOverridesPathologyOverrideIdDeleteRoute;
  '/(practitioner)/company/practitioners/$practitionerId/delete': typeof practitionerCompanyPractitionersPractitionerIdDeleteRoute;
  '/(practitioner)/patients/$patientId/diagnostic-report/$diagnosticReportId': typeof practitionerPatientsPatientIdDiagnosticReportDiagnosticReportIdRoute;
  '/(practitioner)/patients/$patientId/encounters/$encounterId': typeof practitionerPatientsPatientIdEncountersEncounterIdRoute;
  '/(practitioner)/patients/$patientId/temporary-images/upload': typeof practitionerPatientsPatientIdTemporaryImagesUploadRoute;
  '/(practitioner)/practitioner/medication-requests/$medicationRequestId/delete': typeof practitionerPractitionerMedicationRequestsMedicationRequestIdDeleteRoute;
  '/(practitioner)/practitioner/medication-requests/$medicationRequestId/edit': typeof practitionerPractitionerMedicationRequestsMedicationRequestIdEditRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/app-home'
    | '/confirm'
    | '/confirm-account'
    | '/login'
    | '/patient-signup'
    | '/recover-password'
    | '/register'
    | '/reset-password'
    | '/diagnostic-reports'
    | '/documents'
    | '/encounters'
    | '/events'
    | '/global-diagnostic-reports'
    | '/medication-requests'
    | '/company'
    | '/patients'
    | '/legal'
    | '/support'
    | '/audit-log'
    | '/backup'
    | '/contact'
    | '/home'
    | '/logout'
    | '/notifications'
    | '/profile'
    | '/diagnostic-reports/$diagnosticReportId'
    | '/documents/create'
    | '/patient/diagnostic-report-request'
    | '/patient/diagnostic-report-sent'
    | '/patient/payment-orders'
    | '/patient/psoriasis-info'
    | '/company/inactive-company'
    | '/company/metrics'
    | '/company/pathology-customization'
    | '/company/practitioners'
    | '/patients/$patientId'
    | '/patients/create'
    | '/practitioner/activity'
    | '/practitioner/diagnostic-report-request'
    | '/practitioner/diagnostic-report-sent'
    | '/practitioner/patient-payment-orders'
    | '/practitioner/quick-diagnostic-report-request'
    | '/practitioner/work-list'
    | '/disable-emails/$token'
    | '/events/$eventId'
    | '/company/pathology-customization/create'
    | '/company/practitioners/$practitionerId'
    | '/company/practitioners/create'
    | '/patients/$patientId/delete'
    | '/patients/$patientId/patient-interactions'
    | '/patients/$patientId/recover-password'
    | '/patients/$patientId/terminate-study'
    | '/practitioner/activity/$date'
    | '/practitioner/events/$eventId'
    | '/practitioner/events/create'
    | '/practitioner/medication-requests/create'
    | '/practitioner/patient-payment-orders/create'
    | '/practitioners/$practitionerId/recover-password'
    | '/medication-requests/$medicationRequestId/pdf'
    | '/patient/payment-orders/$paymentOrderId/pay'
    | '/company/pathology-customization/$pathologyId/edit'
    | '/company/pathology-overrides/$pathologyOverrideId/delete'
    | '/company/practitioners/$practitionerId/delete'
    | '/patients/$patientId/diagnostic-report/$diagnosticReportId'
    | '/patients/$patientId/encounters/$encounterId'
    | '/patients/$patientId/temporary-images/upload'
    | '/practitioner/medication-requests/$medicationRequestId/delete'
    | '/practitioner/medication-requests/$medicationRequestId/edit';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/app-home'
    | '/confirm'
    | '/confirm-account'
    | '/login'
    | '/patient-signup'
    | '/recover-password'
    | '/register'
    | '/reset-password'
    | '/diagnostic-reports'
    | '/documents'
    | '/encounters'
    | '/events'
    | '/global-diagnostic-reports'
    | '/medication-requests'
    | '/company'
    | '/patients'
    | '/legal'
    | '/support'
    | '/audit-log'
    | '/backup'
    | '/contact'
    | '/home'
    | '/logout'
    | '/notifications'
    | '/profile'
    | '/diagnostic-reports/$diagnosticReportId'
    | '/documents/create'
    | '/patient/diagnostic-report-request'
    | '/patient/diagnostic-report-sent'
    | '/patient/payment-orders'
    | '/patient/psoriasis-info'
    | '/company/inactive-company'
    | '/company/metrics'
    | '/company/pathology-customization'
    | '/company/practitioners'
    | '/patients/$patientId'
    | '/patients/create'
    | '/practitioner/activity'
    | '/practitioner/diagnostic-report-request'
    | '/practitioner/diagnostic-report-sent'
    | '/practitioner/patient-payment-orders'
    | '/practitioner/quick-diagnostic-report-request'
    | '/practitioner/work-list'
    | '/disable-emails/$token'
    | '/events/$eventId'
    | '/company/pathology-customization/create'
    | '/company/practitioners/$practitionerId'
    | '/company/practitioners/create'
    | '/patients/$patientId/delete'
    | '/patients/$patientId/patient-interactions'
    | '/patients/$patientId/recover-password'
    | '/patients/$patientId/terminate-study'
    | '/practitioner/activity/$date'
    | '/practitioner/events/$eventId'
    | '/practitioner/events/create'
    | '/practitioner/medication-requests/create'
    | '/practitioner/patient-payment-orders/create'
    | '/practitioners/$practitionerId/recover-password'
    | '/medication-requests/$medicationRequestId/pdf'
    | '/patient/payment-orders/$paymentOrderId/pay'
    | '/company/pathology-customization/$pathologyId/edit'
    | '/company/pathology-overrides/$pathologyOverrideId/delete'
    | '/company/practitioners/$practitionerId/delete'
    | '/patients/$patientId/diagnostic-report/$diagnosticReportId'
    | '/patients/$patientId/encounters/$encounterId'
    | '/patients/$patientId/temporary-images/upload'
    | '/practitioner/medication-requests/$medicationRequestId/delete'
    | '/practitioner/medication-requests/$medicationRequestId/edit';
  id:
    | '__root__'
    | '/(anonymous)'
    | '/(patient)'
    | '/(practitioner)'
    | '/(public)'
    | '/(shared)'
    | '/(anonymous)/app-home'
    | '/(anonymous)/confirm'
    | '/(anonymous)/confirm-account'
    | '/(anonymous)/login'
    | '/(anonymous)/patient-signup'
    | '/(anonymous)/recover-password'
    | '/(anonymous)/register'
    | '/(anonymous)/reset-password'
    | '/(patient)/diagnostic-reports'
    | '/(patient)/documents'
    | '/(patient)/encounters'
    | '/(patient)/events'
    | '/(patient)/global-diagnostic-reports'
    | '/(patient)/medication-requests'
    | '/(practitioner)/company'
    | '/(practitioner)/diagnostic-reports'
    | '/(practitioner)/patients'
    | '/(public)/legal'
    | '/(public)/support'
    | '/(shared)/audit-log'
    | '/(shared)/backup'
    | '/(shared)/contact'
    | '/(shared)/home'
    | '/(shared)/logout'
    | '/(shared)/notifications'
    | '/(shared)/profile'
    | '/(patient)/diagnostic-reports/$diagnosticReportId'
    | '/(patient)/documents/create'
    | '/(patient)/patient/diagnostic-report-request'
    | '/(patient)/patient/diagnostic-report-sent'
    | '/(patient)/patient/payment-orders'
    | '/(patient)/patient/psoriasis-info'
    | '/(practitioner)/company/inactive-company'
    | '/(practitioner)/company/metrics'
    | '/(practitioner)/company/pathology-customization'
    | '/(practitioner)/company/practitioners'
    | '/(practitioner)/patients/$patientId'
    | '/(practitioner)/patients/create'
    | '/(practitioner)/practitioner/activity'
    | '/(practitioner)/practitioner/diagnostic-report-request'
    | '/(practitioner)/practitioner/diagnostic-report-sent'
    | '/(practitioner)/practitioner/patient-payment-orders'
    | '/(practitioner)/practitioner/quick-diagnostic-report-request'
    | '/(practitioner)/practitioner/work-list'
    | '/(public)/disable-emails/$token'
    | '/(shared)/events/$eventId'
    | '/(practitioner)/company/pathology-customization/create'
    | '/(practitioner)/company/practitioners/$practitionerId'
    | '/(practitioner)/company/practitioners/create'
    | '/(practitioner)/patients/$patientId/delete'
    | '/(practitioner)/patients/$patientId/patient-interactions'
    | '/(practitioner)/patients/$patientId/recover-password'
    | '/(practitioner)/patients/$patientId/terminate-study'
    | '/(practitioner)/practitioner/activity/$date'
    | '/(practitioner)/practitioner/events/$eventId'
    | '/(practitioner)/practitioner/events/create'
    | '/(practitioner)/practitioner/medication-requests/create'
    | '/(practitioner)/practitioner/patient-payment-orders/create'
    | '/(practitioner)/practitioners/$practitionerId/recover-password'
    | '/(shared)/medication-requests/$medicationRequestId/pdf'
    | '/(patient)/patient/payment-orders/$paymentOrderId/pay'
    | '/(practitioner)/company/pathology-customization/$pathologyId/edit'
    | '/(practitioner)/company/pathology-overrides/$pathologyOverrideId/delete'
    | '/(practitioner)/company/practitioners/$practitionerId/delete'
    | '/(practitioner)/patients/$patientId/diagnostic-report/$diagnosticReportId'
    | '/(practitioner)/patients/$patientId/encounters/$encounterId'
    | '/(practitioner)/patients/$patientId/temporary-images/upload'
    | '/(practitioner)/practitioner/medication-requests/$medicationRequestId/delete'
    | '/(practitioner)/practitioner/medication-requests/$medicationRequestId/edit';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  anonymousRouteRoute: typeof anonymousRouteRouteWithChildren;
  patientRouteRoute: typeof patientRouteRouteWithChildren;
  practitionerRouteRoute: typeof practitionerRouteRouteWithChildren;
  publicRouteRoute: typeof publicRouteRouteWithChildren;
  sharedRouteRoute: typeof sharedRouteRouteWithChildren;
}

const rootRouteChildren: RootRouteChildren = {
  anonymousRouteRoute: anonymousRouteRouteWithChildren,
  patientRouteRoute: patientRouteRouteWithChildren,
  practitionerRouteRoute: practitionerRouteRouteWithChildren,
  publicRouteRoute: publicRouteRouteWithChildren,
  sharedRouteRoute: sharedRouteRouteWithChildren
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/(anonymous)",
        "/(patient)",
        "/(practitioner)",
        "/(public)",
        "/(shared)"
      ]
    },
    "/(anonymous)": {
      "filePath": "(anonymous)/route.tsx",
      "children": [
        "/(anonymous)/app-home",
        "/(anonymous)/confirm",
        "/(anonymous)/confirm-account",
        "/(anonymous)/login",
        "/(anonymous)/patient-signup",
        "/(anonymous)/recover-password",
        "/(anonymous)/register",
        "/(anonymous)/reset-password"
      ]
    },
    "/(patient)": {
      "filePath": "(patient)/route.tsx",
      "children": [
        "/(patient)/diagnostic-reports",
        "/(patient)/documents",
        "/(patient)/encounters",
        "/(patient)/events",
        "/(patient)/global-diagnostic-reports",
        "/(patient)/medication-requests",
        "/(patient)/patient/diagnostic-report-request",
        "/(patient)/patient/diagnostic-report-sent",
        "/(patient)/patient/payment-orders",
        "/(patient)/patient/psoriasis-info"
      ]
    },
    "/(practitioner)": {
      "filePath": "(practitioner)/route.tsx",
      "children": [
        "/(practitioner)/company",
        "/(practitioner)/diagnostic-reports",
        "/(practitioner)/patients",
        "/(practitioner)/practitioner/activity",
        "/(practitioner)/practitioner/diagnostic-report-request",
        "/(practitioner)/practitioner/diagnostic-report-sent",
        "/(practitioner)/practitioner/patient-payment-orders",
        "/(practitioner)/practitioner/quick-diagnostic-report-request",
        "/(practitioner)/practitioner/work-list",
        "/(practitioner)/practitioner/events/$eventId",
        "/(practitioner)/practitioner/events/create",
        "/(practitioner)/practitioner/medication-requests/create",
        "/(practitioner)/practitioners/$practitionerId/recover-password",
        "/(practitioner)/practitioner/medication-requests/$medicationRequestId/delete",
        "/(practitioner)/practitioner/medication-requests/$medicationRequestId/edit"
      ]
    },
    "/(public)": {
      "filePath": "(public)/route.tsx",
      "children": [
        "/(public)/legal",
        "/(public)/support",
        "/(public)/disable-emails/$token"
      ]
    },
    "/(shared)": {
      "filePath": "(shared)/route.tsx",
      "children": [
        "/(shared)/audit-log",
        "/(shared)/backup",
        "/(shared)/contact",
        "/(shared)/home",
        "/(shared)/logout",
        "/(shared)/notifications",
        "/(shared)/profile",
        "/(shared)/events/$eventId",
        "/(shared)/medication-requests/$medicationRequestId/pdf"
      ]
    },
    "/(anonymous)/app-home": {
      "filePath": "(anonymous)/app-home.tsx",
      "parent": "/(anonymous)"
    },
    "/(anonymous)/confirm": {
      "filePath": "(anonymous)/confirm.tsx",
      "parent": "/(anonymous)"
    },
    "/(anonymous)/confirm-account": {
      "filePath": "(anonymous)/confirm-account.tsx",
      "parent": "/(anonymous)"
    },
    "/(anonymous)/login": {
      "filePath": "(anonymous)/login.tsx",
      "parent": "/(anonymous)"
    },
    "/(anonymous)/patient-signup": {
      "filePath": "(anonymous)/patient-signup.tsx",
      "parent": "/(anonymous)"
    },
    "/(anonymous)/recover-password": {
      "filePath": "(anonymous)/recover-password.tsx",
      "parent": "/(anonymous)"
    },
    "/(anonymous)/register": {
      "filePath": "(anonymous)/register.tsx",
      "parent": "/(anonymous)"
    },
    "/(anonymous)/reset-password": {
      "filePath": "(anonymous)/reset-password.tsx",
      "parent": "/(anonymous)"
    },
    "/(patient)/diagnostic-reports": {
      "filePath": "(patient)/diagnostic-reports.tsx",
      "parent": "/(patient)",
      "children": [
        "/(patient)/diagnostic-reports/$diagnosticReportId"
      ]
    },
    "/(patient)/documents": {
      "filePath": "(patient)/documents.tsx",
      "parent": "/(patient)",
      "children": [
        "/(patient)/documents/create"
      ]
    },
    "/(patient)/encounters": {
      "filePath": "(patient)/encounters.tsx",
      "parent": "/(patient)"
    },
    "/(patient)/events": {
      "filePath": "(patient)/events.tsx",
      "parent": "/(patient)"
    },
    "/(patient)/global-diagnostic-reports": {
      "filePath": "(patient)/global-diagnostic-reports.tsx",
      "parent": "/(patient)"
    },
    "/(patient)/medication-requests": {
      "filePath": "(patient)/medication-requests.tsx",
      "parent": "/(patient)"
    },
    "/(practitioner)/company": {
      "filePath": "(practitioner)/company.tsx",
      "parent": "/(practitioner)",
      "children": [
        "/(practitioner)/company/inactive-company",
        "/(practitioner)/company/metrics",
        "/(practitioner)/company/pathology-customization",
        "/(practitioner)/company/practitioners",
        "/(practitioner)/company/pathology-overrides/$pathologyOverrideId/delete"
      ]
    },
    "/(practitioner)/diagnostic-reports": {
      "filePath": "(practitioner)/diagnostic-reports.tsx",
      "parent": "/(practitioner)"
    },
    "/(practitioner)/patients": {
      "filePath": "(practitioner)/patients.tsx",
      "parent": "/(practitioner)",
      "children": [
        "/(practitioner)/patients/$patientId",
        "/(practitioner)/patients/create"
      ]
    },
    "/(public)/legal": {
      "filePath": "(public)/legal.tsx",
      "parent": "/(public)"
    },
    "/(public)/support": {
      "filePath": "(public)/support.tsx",
      "parent": "/(public)"
    },
    "/(shared)/audit-log": {
      "filePath": "(shared)/audit-log.tsx",
      "parent": "/(shared)"
    },
    "/(shared)/backup": {
      "filePath": "(shared)/backup.tsx",
      "parent": "/(shared)"
    },
    "/(shared)/contact": {
      "filePath": "(shared)/contact.tsx",
      "parent": "/(shared)"
    },
    "/(shared)/home": {
      "filePath": "(shared)/home.tsx",
      "parent": "/(shared)"
    },
    "/(shared)/logout": {
      "filePath": "(shared)/logout.tsx",
      "parent": "/(shared)"
    },
    "/(shared)/notifications": {
      "filePath": "(shared)/notifications.tsx",
      "parent": "/(shared)"
    },
    "/(shared)/profile": {
      "filePath": "(shared)/profile.tsx",
      "parent": "/(shared)"
    },
    "/(patient)/diagnostic-reports/$diagnosticReportId": {
      "filePath": "(patient)/diagnostic-reports/$diagnosticReportId.tsx",
      "parent": "/(patient)/diagnostic-reports"
    },
    "/(patient)/documents/create": {
      "filePath": "(patient)/documents/create.tsx",
      "parent": "/(patient)/documents"
    },
    "/(patient)/patient/diagnostic-report-request": {
      "filePath": "(patient)/patient/diagnostic-report-request.tsx",
      "parent": "/(patient)"
    },
    "/(patient)/patient/diagnostic-report-sent": {
      "filePath": "(patient)/patient/diagnostic-report-sent.tsx",
      "parent": "/(patient)"
    },
    "/(patient)/patient/payment-orders": {
      "filePath": "(patient)/patient/payment-orders.tsx",
      "parent": "/(patient)",
      "children": [
        "/(patient)/patient/payment-orders/$paymentOrderId/pay"
      ]
    },
    "/(patient)/patient/psoriasis-info": {
      "filePath": "(patient)/patient/psoriasis-info.tsx",
      "parent": "/(patient)"
    },
    "/(practitioner)/company/inactive-company": {
      "filePath": "(practitioner)/company/inactive-company.tsx",
      "parent": "/(practitioner)/company"
    },
    "/(practitioner)/company/metrics": {
      "filePath": "(practitioner)/company/metrics.tsx",
      "parent": "/(practitioner)/company"
    },
    "/(practitioner)/company/pathology-customization": {
      "filePath": "(practitioner)/company/pathology-customization.tsx",
      "parent": "/(practitioner)/company",
      "children": [
        "/(practitioner)/company/pathology-customization/create",
        "/(practitioner)/company/pathology-customization/$pathologyId/edit"
      ]
    },
    "/(practitioner)/company/practitioners": {
      "filePath": "(practitioner)/company/practitioners.tsx",
      "parent": "/(practitioner)/company",
      "children": [
        "/(practitioner)/company/practitioners/$practitionerId",
        "/(practitioner)/company/practitioners/create"
      ]
    },
    "/(practitioner)/patients/$patientId": {
      "filePath": "(practitioner)/patients/$patientId.tsx",
      "parent": "/(practitioner)/patients",
      "children": [
        "/(practitioner)/patients/$patientId/delete",
        "/(practitioner)/patients/$patientId/patient-interactions",
        "/(practitioner)/patients/$patientId/recover-password",
        "/(practitioner)/patients/$patientId/terminate-study",
        "/(practitioner)/patients/$patientId/diagnostic-report/$diagnosticReportId",
        "/(practitioner)/patients/$patientId/encounters/$encounterId",
        "/(practitioner)/patients/$patientId/temporary-images/upload"
      ]
    },
    "/(practitioner)/patients/create": {
      "filePath": "(practitioner)/patients/create.tsx",
      "parent": "/(practitioner)/patients"
    },
    "/(practitioner)/practitioner/activity": {
      "filePath": "(practitioner)/practitioner/activity.tsx",
      "parent": "/(practitioner)",
      "children": [
        "/(practitioner)/practitioner/activity/$date"
      ]
    },
    "/(practitioner)/practitioner/diagnostic-report-request": {
      "filePath": "(practitioner)/practitioner/diagnostic-report-request.tsx",
      "parent": "/(practitioner)"
    },
    "/(practitioner)/practitioner/diagnostic-report-sent": {
      "filePath": "(practitioner)/practitioner/diagnostic-report-sent.tsx",
      "parent": "/(practitioner)"
    },
    "/(practitioner)/practitioner/patient-payment-orders": {
      "filePath": "(practitioner)/practitioner/patient-payment-orders.tsx",
      "parent": "/(practitioner)",
      "children": [
        "/(practitioner)/practitioner/patient-payment-orders/create"
      ]
    },
    "/(practitioner)/practitioner/quick-diagnostic-report-request": {
      "filePath": "(practitioner)/practitioner/quick-diagnostic-report-request.tsx",
      "parent": "/(practitioner)"
    },
    "/(practitioner)/practitioner/work-list": {
      "filePath": "(practitioner)/practitioner/work-list.tsx",
      "parent": "/(practitioner)"
    },
    "/(public)/disable-emails/$token": {
      "filePath": "(public)/disable-emails/$token.tsx",
      "parent": "/(public)"
    },
    "/(shared)/events/$eventId": {
      "filePath": "(shared)/events/$eventId.tsx",
      "parent": "/(shared)"
    },
    "/(practitioner)/company/pathology-customization/create": {
      "filePath": "(practitioner)/company/pathology-customization/create.tsx",
      "parent": "/(practitioner)/company/pathology-customization"
    },
    "/(practitioner)/company/practitioners/$practitionerId": {
      "filePath": "(practitioner)/company/practitioners/$practitionerId.tsx",
      "parent": "/(practitioner)/company/practitioners",
      "children": [
        "/(practitioner)/company/practitioners/$practitionerId/delete"
      ]
    },
    "/(practitioner)/company/practitioners/create": {
      "filePath": "(practitioner)/company/practitioners/create.tsx",
      "parent": "/(practitioner)/company/practitioners"
    },
    "/(practitioner)/patients/$patientId/delete": {
      "filePath": "(practitioner)/patients/$patientId/delete.tsx",
      "parent": "/(practitioner)/patients/$patientId"
    },
    "/(practitioner)/patients/$patientId/patient-interactions": {
      "filePath": "(practitioner)/patients/$patientId/patient-interactions.tsx",
      "parent": "/(practitioner)/patients/$patientId"
    },
    "/(practitioner)/patients/$patientId/recover-password": {
      "filePath": "(practitioner)/patients/$patientId/recover-password.tsx",
      "parent": "/(practitioner)/patients/$patientId"
    },
    "/(practitioner)/patients/$patientId/terminate-study": {
      "filePath": "(practitioner)/patients/$patientId/terminate-study.tsx",
      "parent": "/(practitioner)/patients/$patientId"
    },
    "/(practitioner)/practitioner/activity/$date": {
      "filePath": "(practitioner)/practitioner/activity/$date.tsx",
      "parent": "/(practitioner)/practitioner/activity"
    },
    "/(practitioner)/practitioner/events/$eventId": {
      "filePath": "(practitioner)/practitioner/events/$eventId.tsx",
      "parent": "/(practitioner)"
    },
    "/(practitioner)/practitioner/events/create": {
      "filePath": "(practitioner)/practitioner/events/create.tsx",
      "parent": "/(practitioner)"
    },
    "/(practitioner)/practitioner/medication-requests/create": {
      "filePath": "(practitioner)/practitioner/medication-requests/create.tsx",
      "parent": "/(practitioner)"
    },
    "/(practitioner)/practitioner/patient-payment-orders/create": {
      "filePath": "(practitioner)/practitioner/patient-payment-orders/create.tsx",
      "parent": "/(practitioner)/practitioner/patient-payment-orders"
    },
    "/(practitioner)/practitioners/$practitionerId/recover-password": {
      "filePath": "(practitioner)/practitioners/$practitionerId/recover-password.tsx",
      "parent": "/(practitioner)"
    },
    "/(shared)/medication-requests/$medicationRequestId/pdf": {
      "filePath": "(shared)/medication-requests/$medicationRequestId/pdf.tsx",
      "parent": "/(shared)"
    },
    "/(patient)/patient/payment-orders/$paymentOrderId/pay": {
      "filePath": "(patient)/patient/payment-orders/$paymentOrderId/pay.tsx",
      "parent": "/(patient)/patient/payment-orders"
    },
    "/(practitioner)/company/pathology-customization/$pathologyId/edit": {
      "filePath": "(practitioner)/company/pathology-customization/$pathologyId/edit.tsx",
      "parent": "/(practitioner)/company/pathology-customization"
    },
    "/(practitioner)/company/pathology-overrides/$pathologyOverrideId/delete": {
      "filePath": "(practitioner)/company/pathology-overrides/$pathologyOverrideId/delete.tsx",
      "parent": "/(practitioner)/company"
    },
    "/(practitioner)/company/practitioners/$practitionerId/delete": {
      "filePath": "(practitioner)/company/practitioners/$practitionerId/delete.tsx",
      "parent": "/(practitioner)/company/practitioners/$practitionerId"
    },
    "/(practitioner)/patients/$patientId/diagnostic-report/$diagnosticReportId": {
      "filePath": "(practitioner)/patients/$patientId/diagnostic-report/$diagnosticReportId.tsx",
      "parent": "/(practitioner)/patients/$patientId"
    },
    "/(practitioner)/patients/$patientId/encounters/$encounterId": {
      "filePath": "(practitioner)/patients/$patientId/encounters/$encounterId.tsx",
      "parent": "/(practitioner)/patients/$patientId"
    },
    "/(practitioner)/patients/$patientId/temporary-images/upload": {
      "filePath": "(practitioner)/patients/$patientId/temporary-images/upload.tsx",
      "parent": "/(practitioner)/patients/$patientId"
    },
    "/(practitioner)/practitioner/medication-requests/$medicationRequestId/delete": {
      "filePath": "(practitioner)/practitioner/medication-requests/$medicationRequestId/delete.tsx",
      "parent": "/(practitioner)"
    },
    "/(practitioner)/practitioner/medication-requests/$medicationRequestId/edit": {
      "filePath": "(practitioner)/practitioner/medication-requests/$medicationRequestId/edit.tsx",
      "parent": "/(practitioner)"
    }
  }
}
ROUTE_MANIFEST_END */
